(function() {
    'use strict';

    angular
        .module('ArEmail', [
            'ngAnimate',
            'ngCookies',
            'ngTouch',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'ngResource',
            'ui.router',
            'ui.bootstrap',
            'toastr',
            'logger',
            'oitozero.ngSweetAlert',
            'ngCsvImport',
            'ui.tinymce',
			'datatables.light-columnfilter',
            'datatables',
            'datatables.bootstrap',
            'datatables.columnfilter',
			'datatablesOption',
            'angular-loading-bar',
            'selector',
            'ui.select',
            'logger',
            'exception',
            'ui.utils.masks',
            'addValueInput',
            'tinymceOption',
            'csvOption',
            'ngFileUpload',
            'ngFileSaver',
            'color.picker',
            'pdf'
        ]);

    $(document).ready(function() {
        $(function() {
            $(document).on('scroll', function() {
                if ($(window).scrollTop() > 100) {
                    $('.scroll-top-wrapper').addClass('show');
                } else {
                    $('.scroll-top-wrapper').removeClass('show');
                }
            });
            $('.scroll-top-wrapper').on('click', scrollToTop);
        });

        function scrollToTop() {
            var verticalOffset = typeof(verticalOffset) !== 'undefined' ? verticalOffset : 0;
            var element = $('body');
            var offset = element.offset();
            var offsetTop = offset.top;
            $('html, body').animate({
                scrollTop: offsetTop
            }, 500, 'linear');
        }
    });






})();

(function() {
  'use strict';
  angular
    .module('ArEmail')
    .controller('TinyMceController', TinyMceController);

  function TinyMceController(SweetAlert) {

    var vm = this;
    vm.tituloView = 'Teste com TinyMce';
    vm.tinymceModel = 'Initial content';

    vm.getContent = function() {
      //console.log('Editor content:', vm.tinymceModel);
      SweetAlert.swal('Get a Content', vm.tinymceModel, 'success');
    };

    vm.setContent = function() {
      vm.tinymceModel = 'Time: ' + (new Date());
    };

    vm.tinymceOptions = {
      plugins: 'link image code',
      toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code'
    };

  }

})();

// (function() {
//   'use strict';
//   angular
//     .module('ArEmail')
//     .factory('emailUnicoService', emailUnicoService);
//
//   emailUnicoService.$inject = ['$http', 'API', 'TOKEN', 'logger'];
//
//   /*@ngInject*/
//   function emailUnicoService($http, API, TOKEN, logger) {
//     var service = {
//       sendEmail: sendEmail,
//     };
//     return service;
//
//     function sendEmail(envelope) {
//       return $http.post(API + '/email', envelope, {
//           headers: {
//             token: TOKEN
//           }
//         })
//         .then(function(response) {
//           return response.data.result;
//         })
//         .catch(function(err) {
//           throw err;
//         });
//     }
//   }
//
// })();

(function() {
  'use strict';
  angular
    .module('ArEmail')
    .controller('EmailUnicoController', EmailUnicoController);

  function EmailUnicoController(SweetAlert, emailUnicoService, usuarioService, $log, $q, logger) {

    var vm = this;
    vm.tituloView = 'E-mail Único';



    activate();

    function activate() {
      var promises = [getAllUsuario(), initForm()];
      return $q.all(promises).then(function() {});
    }

    //FIXME isso sai quando o login estiver funcionando
    function getAllUsuario() {
      usuarioService.getAllUsuario()
        .then(function(response) {
          if (response.success) {
            vm.formEmail.usuarios = response.data.map(function(element) {
              return {
                value: element.usu_codigo,
                name: element.usu_nome
              };
            });
          }
        });
    }

    function initForm() {
      vm.formEmail = {
        codUsuario: '',
        nameTo: 'Welinton',
        to: 'welinton@realizati.com.br',
        subject: 'teste com o ar-email',
        valid: false,
        content: '<h1> Olá da Plataforma </h1>'
      };
    }


    vm.submitForm = function() {
      emailUnicoService.sendEmail(vm.formEmail)
        .then(function() {
          SweetAlert.swal('Email enviado com sucesso', '', 'success');
          initForm();
        })
        .catch(function() {
          SweetAlert.swal('Erro', 'Houve um erro no envio do e-mail', 'error');
        });
    };



    vm.tinymceOptions = {
      height: 300,
      language_url: '/assets/langs/pt_BR.js',
      plugins: ['advlist autolink lists link image charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table contextmenu paste code textcolor'],
      toolbar: 'undo redo | formatselect fontselect fontsizeselect forecolor backcolor | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image | cut copy paste pastetext removeformat | code preview print | varbutton ',
      setup: function(editor) {
        editor.addButton('varbutton', {
          type: 'menubutton',
          text: 'Variáveis',
          icon: false,
          menu: [{
            text: 'Nome Completo',
            onclick: function() {
              editor.insertContent('*|NOME|*');
            }
          }, {
            text: 'Primeiro Nome',
            onclick: function() {
              editor.insertContent('*|PRIMEIRO NOME|*');
            }
          }, {
            text: 'Segundo Nome',
            onclick: function() {
              editor.insertContent('*|SOBRENOME|*');
            }
          }, {
            text: 'E-mail',
            onclick: function() {
              editor.insertContent('*|EMAIL|*');
            }
          }, {
            text: 'Telefone',
            onclick: function() {
              editor.insertContent('*|TELEFONE|*');
            }
          }, {
            text: 'Documento',
            onclick: function() {
              editor.insertContent('*|DOCUMENTO|*');
            }
          }, {
            text: 'Endereço',
            onclick: function() {
              editor.insertContent('*|ENDERECO|*');
            }
          }, {
            text: 'Cidade',
            onclick: function() {
              editor.insertContent('*|CIDADE|*');
            }
          }, {
            text: 'Estado',
            onclick: function() {
              editor.insertContent('*|UF|*');
            }
          }, {
            text: 'Data de Nascimento',
            onclick: function() {
              editor.insertContent('*|NASCIMENTO|*');
            }
          }, {
            text: 'Profissão',
            onclick: function() {
              editor.insertContent('*|PROFISSAO|*');
            }
          }, {
            text: 'Estado Civil',
            onclick: function() {
              editor.insertContent('*|EST CIVIL|*');
            }
          }, {
            text: 'CNPJ',
            onclick: function() {
              editor.insertContent('*|CNPJ|*');
            }
          }, {
            text: 'CPF',
            onclick: function() {
              editor.insertContent('*|CPF|*');
            }
          }, {
            text: 'Nome Fantasia',
            onclick: function() {
              editor.insertContent('*|NOME FANTASIA|*');
            }
          }, {
            text: 'Razão Social',
            onclick: function() {
              editor.insertContent('*|RAZAO SOCIAL|*');
            }
          }, {
            text: 'Inscrição Estadual',
            onclick: function() {
              editor.insertContent('*|INSC EST|*');
            }
          }, {
            text: 'Celular',
            onclick: function() {
              editor.insertContent('*|CELULAR|*');
            }
          }, {
            text: 'Sexo',
            onclick: function() {
              editor.insertContent('*|SEXO|*');
            }
          }, {
            text: 'CEP',
            onclick: function() {
              editor.insertContent('*|CEP|*');
            }
          }, ]
        });
      },
    };

  }
})();

(function() {
  'use strict';
  angular
    .module('ArEmail')
    .controller('DataTableController', DataTableController);

  function DataTableController(DTOptionsBuilder, DTColumnDefBuilder) {

    var vm = this;
    vm.tituloView = 'Teste com DataTables';

    vm.dtOptions = DTOptionsBuilder.newOptions()
      .withPaginationType('full_numbers')
      .withDisplayLength(2)
      .withDOM('pitrfl')
      .withBootstrap();
    vm.dtColumnDefs = [
      DTColumnDefBuilder.newColumnDef(0),
      DTColumnDefBuilder.newColumnDef(1).notVisible(),
      DTColumnDefBuilder.newColumnDef(2).notSortable()
    ];

  }

})();

(function() {
  'use strict';
  angular
    .module('ArEmail')
    .controller('CsvController', CsvController);


  /** @ngInject*/
  function CsvController(toastr, $log, $q, $parse) {

    var vm = this;

    vm.tituloView = 'Testes';

    activate();

    function activate() {
      var promises = [];
      return $q.all(promises)
        .then(function() {});
    }


    //######### USO DO CSV ###########
    vm.csv = {
      content: null,
      header: true,
      headerVisible: true,
      separator: ';',
      separatorVisible: true,
      result: null,
      encoding: 'ISO-8859-1',
      encodingVisible: true
    };


    var _lastGoodResult = '';

    vm.toPrettyJSON = function(json, tabWidth) {
      $log.log(json);
      if (json) {
        json.forEach(function(element, index) {
          if (index === 0) {
            $log.log(Object.keys(element));
          }
        });
      }
      var objStr = JSON.stringify(json);
      var obj = null;
      try {
        obj = $parse(objStr)({});
      } catch (e) {
        // eat $parse error
        return _lastGoodResult;
      }

      var result = JSON.stringify(obj, null, Number(tabWidth));
      _lastGoodResult = result;
      return result;

    };
    //######### USO DO CSV ###########


  }


})();

(function() {
  'use strict';

  angular
      .module('ArEmail')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('ArEmail')
        .directive('acmeNavbar', acmeNavbar);

    /** @ngInject */
    function acmeNavbar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {
                creationDate: '='
            },
            controller: NavbarController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function NavbarController(moment, USER) {
            var vm = this;
            vm.alerts = [
            //   {
    //     type: 'danger',
    //     msg: 'Oh snap! Change a few things up and try submitting again. <a href="/configuracao">configuração</a>'
    // }
          ];
            vm.closeAlert = function (index) {
                vm.alerts.splice(index, 1);
            };
            vm.user = USER;
            // "vm.creationDate" is available by directive option "bindToController: true"
            vm.relativeDate = moment(vm.creationDate).fromNow();
        }

    }

})();

(function() {
  'use strict';

  angular
    .module('ArEmail')
    .directive('bsNavbar', bsNavbar); // JavaScript Document



  /** @ngInject */
  function bsNavbar($location) {

    return {
      restrict: 'A',
      link: function postLink(scope, element, attrs, controller) {
        // Watch for the $location
        scope.$watch(function() {
          return $location.path();
        }, function(newValue, oldValue) {

          $('li[data-match-route]', element).each(function(k, li) {
            var $li = angular.element(li),
              // data('match-rout') does not work with dynamic attributes
              pattern = $li.attr('data-match-route'),
              regexp = new RegExp('^' + pattern + '$', ['i']);

            if (regexp.test(newValue)) {
              $li.addClass('active');
            } else {
              $li.removeClass('active');
            }

          });
        });
      }

    };
  }

})();

(function() {
  'use strict';

  angular
    .module('ArEmail')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('ArEmail')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
    'use strict';
    angular.module('tinymceOption', []);
})();

(function() {
    'use strict';

    angular
        .module('tinymceOption')
        .factory('tinymceOption', tinymceOption);

    function tinymceOption() {
        var service = {
            buildOptions: buildOptions(),
        };

        return service;

        function buildOptions() {
            var options = {
                height: 300,
                language_url: '/assets/langs/pt_BR.js',
                plugins: ['advlist autolink lists link image charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table contextmenu paste code textcolor'],
                toolbar: 'undo redo | formatselect fontselect | fontsizeselect forecolor backcolor | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image | cut copy paste pastetext removeformat | code preview print | varbutton ',

            };

            return options;
        }
    }
}());

(function() {
    'use strict';

    angular.module('logger', []);
})();

(function() {
    'use strict';

    angular
        .module('logger')
        .factory('logger', logger);

    logger.$inject = ['$log', 'toastr'];

    /* @ngInject */
    function logger($log, toastr) {
        var service = {
            showToasts: true,

            error   : error,
            info    : info,
            success : success,
            warning : warning,

            // straight to console; bypass toastr
            log     : $log.log
        };

        return service;
        /////////////////////

        function error(message, data, title) {
            toastr.error(message, title);
            $log.error('Error: ' + message, data);
        }

        function info(message, data, title) {
            toastr.info(message, title);
            $log.info('Info: ' + message, data);
        }

        function success(message, data, title) {
            toastr.success(message, title);
            $log.info('Success: ' + message, data);
        }

        function warning(message, data, title) {
            toastr.warning(message, title);
            $log.warn('Warning: ' + message, data);
        }
    }
}());

(function() {
    'use strict';
    angular.module('exception', []);
})();

(function () {
  'use strict';

  angular
    .module('exception')
    .factory('exception', exception);

  exception.$inject = ['$location', 'SweetAlert'];

  /* @ngInject */
  function exception($location, SweetAlert) {
    var service = {
      error: error,
    };

    return service;

    function error(err) {

      switch (err.status) {
      case 403:
        status403();
        break;
      case 500:
        status500(err);
        break;
      default:

      }
    }

    function status403() {
      //throw e.data.result;
      //$location.path('/logout');

      SweetAlert.swal({
          title: "Sessão expirada",
          text: "Sessão expirada",
          type: "warning",
          confirmButtonColor: "#ff4136",
          confirmButtonText: "Ok",
          closeOnConfirm: false
        },
        function () {

          window.location.href = '/';
        });

    }

    function status500(e) {
      SweetAlert.swal("Aviso", e.data.result, "error");
    }

  }
}());

(function() {
    'use strict';
    angular.module('datatablesOption', []);
})();

(function() {
    'use strict';

    angular
        .module('datatablesOption')
        .factory('datatablesOption', datatablesOption);

    datatablesOption.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', 'DTColumnDefBuilder', 'DTDefaultOptions'];

    /* @ngInject */
    function datatablesOption(DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, DTDefaultOptions) {

        var service = {
            option: option,
            columnDef: columnDef,
            optionsBuilder: optionsBuilder,
            columnBuilder: columnBuilder
        };

		DTDefaultOptions.setLoadingTemplate('<h2 class="text-center text-primary animated zoomIn">Carregando</h2><div class="spinnerr"><div class="dot1"></div><div class="dot2"></div></div>');

        return service;

        function option(dtOptions) {
              return dtOptions.withOption()
                .withPaginationType('full_numbers')
                .withDisplayLength(10)
                //.withDOM('lfrtip')
				.withDOM("<'row'<'col-xs-12 col-sm-6'l><'col-xs-12 col-sm-6'f>>" + "<'row'<'col-xs-12'tr>>" + "<'row'<'col-xs-12 col-sm-5'i><'col-xs-12 col-sm-7'p>>")
                .withBootstrap()
                .withLanguage({
                    "sEmptyTable": "Nenhum registro encontrado",
                    "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
                    "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                    "sInfoFiltered": "(Filtrados de _MAX_ registros)",
                    "sInfoPostFix": "",
                    "sInfoThousands": ".",
                    "sLengthMenu": "_MENU_ resultados por página",
                    "sLoadingRecords": "Carregando...",
                    "sProcessing": '<h2 class="text-center text-primary animated zoomIn">Carregando</h2><div class="spinnerr"><div class="dot1"></div><div class="dot2"></div></div>',
                    "sZeroRecords": "Nenhum registro encontrado",
                    "sSearch": "Pesquisar",
                    "oPaginate": {
                        "sFirst": "<<",
                        "sLast": ">>",
                        "sNext": ">",
                        "sPrevious": "<"
                    },
                    "oAria": {
                        "sSortAscending": ": Ordenar colunas de forma ascendente",
                        "sSortDescending": ": Ordenar colunas de forma descendente"
                    }
                });

        }

        function columnDef() {
            return DTColumnDefBuilder;
        }

        function optionsBuilder() {
            return DTOptionsBuilder;
        }

        function columnBuilder() {
            return DTColumnBuilder;
        }

    }
}());

/*! Angular-PDF Version: 1.5.0 | Released under an MIT license */
!function(){"use strict";angular.module("pdf",[]).directive("ngPdf",["$window",function($window){var renderTask=null,pdfLoaderTask=null,debug=!1,backingScale=function(canvas){var ctx=canvas.getContext("2d"),dpr=window.devicePixelRatio||1,bsr=ctx.webkitBackingStorePixelRatio||ctx.mozBackingStorePixelRatio||ctx.msBackingStorePixelRatio||ctx.oBackingStorePixelRatio||ctx.backingStorePixelRatio||1;return dpr/bsr},setCanvasDimensions=function(canvas,w,h){var ratio=backingScale(canvas);return canvas.width=Math.floor(w*ratio),canvas.height=Math.floor(h*ratio),canvas.style.width=Math.floor(w)+"px",canvas.style.height=Math.floor(h)+"px",canvas.getContext("2d").setTransform(ratio,0,0,ratio,0,0),canvas};return{restrict:"E",templateUrl:function(element,attr){return attr.templateUrl?attr.templateUrl:"partials/viewer.html"},link:function(scope,element,attrs){function clearCanvas(){ctx&&ctx.clearRect(0,0,canvas.width,canvas.height)}function renderPDF(){clearCanvas();var params={url:url,withCredentials:creds};httpHeaders&&(params.httpHeaders=httpHeaders),url&&url.length&&(pdfLoaderTask=PDFJS.getDocument(params),pdfLoaderTask.onProgress=scope.onProgress,pdfLoaderTask.onPassword=scope.onPassword,pdfLoaderTask.then(function(_pdfDoc){"function"==typeof scope.onLoad&&scope.onLoad(),pdfDoc=_pdfDoc,scope.renderPage(scope.pageToDisplay),scope.$apply(function(){scope.pageCount=_pdfDoc.numPages})},function(error){error&&"function"==typeof scope.onError&&scope.onError(error)}))}element.css("display","block");var url=scope.pdfUrl,httpHeaders=scope.httpHeaders,pdfDoc=null,pageToDisplay=isFinite(attrs.page)?parseInt(attrs.page):1,pageFit="page-fit"===attrs.scale,scale=attrs.scale>0?attrs.scale:1,canvasid=attrs.canvasid||"pdf-canvas",canvas=document.getElementById(canvasid);debug=!!attrs.hasOwnProperty("debug")&&attrs.debug;var creds=attrs.usecredentials,ctx=canvas.getContext("2d"),windowEl=angular.element($window);windowEl.on("scroll",function(){scope.$apply(function(){scope.scroll=windowEl[0].scrollY})}),PDFJS.disableWorker=!0,scope.pageNum=pageToDisplay,scope.renderPage=function(num){renderTask&&renderTask._internalRenderTask.cancel(),pdfDoc.getPage(num).then(function(page){var viewport,pageWidthScale,renderContext;if(pageFit){viewport=page.getViewport(1);var clientRect=element[0].getBoundingClientRect();pageWidthScale=clientRect.width/viewport.width,scale=pageWidthScale}viewport=page.getViewport(scale),setCanvasDimensions(canvas,viewport.width,viewport.height),renderContext={canvasContext:ctx,viewport:viewport},renderTask=page.render(renderContext),renderTask.promise.then(function(){"function"==typeof scope.onPageRender&&scope.onPageRender()}).catch(function(reason){console.log(reason)})})},scope.goPrevious=function(){scope.pageToDisplay<=1||(scope.pageToDisplay=parseInt(scope.pageToDisplay)-1,scope.pageNum=scope.pageToDisplay)},scope.goNext=function(){scope.pageToDisplay>=pdfDoc.numPages||(scope.pageToDisplay=parseInt(scope.pageToDisplay)+1,scope.pageNum=scope.pageToDisplay)},scope.zoomIn=function(){return pageFit=!1,scale=parseFloat(scale)+.2,scope.renderPage(scope.pageToDisplay),scale},scope.zoomOut=function(){return pageFit=!1,scale=parseFloat(scale)-.2,scope.renderPage(scope.pageToDisplay),scale},scope.fit=function(){pageFit=!0,scope.renderPage(scope.pageToDisplay)},scope.changePage=function(){scope.renderPage(scope.pageToDisplay)},scope.rotate=function(){"rotate0"===canvas.getAttribute("class")?canvas.setAttribute("class","rotate90"):"rotate90"===canvas.getAttribute("class")?canvas.setAttribute("class","rotate180"):"rotate180"===canvas.getAttribute("class")?canvas.setAttribute("class","rotate270"):canvas.setAttribute("class","rotate0")},scope.$watch("pageNum",function(newVal){scope.pageToDisplay=parseInt(newVal),null!==pdfDoc&&scope.renderPage(scope.pageToDisplay)}),scope.$watch("pdfUrl",function(newVal){""!==newVal&&(debug&&console.log("pdfUrl value change detected: ",scope.pdfUrl),url=newVal,scope.pageNum=scope.pageToDisplay=pageToDisplay,pdfLoaderTask?pdfLoaderTask.destroy().then(function(){renderPDF()}):renderPDF())})}}}])}();
(function() {
    'use strict';
    angular.module('csvOption', []);
})();

// https://github.com/bahaaldine/angular-csv-import/pull/38/commits/cb6a8ddd96f7a9111eddf188afff4a9e407f705d
(function() {
    'use strict';

    angular
        .module('csvOption')
        .factory('csvOption', csvOption);

    function csvOption() {
        var service = {
            buildOptions: buildOptions(),
        };

        return service;

        function buildOptions() {
            var options = {
                content: null,
                header: true,
                headerVisible: true,
                separator: ';',
                separatorVisible: true,
                result: null,
                encoding: 'ISO-8859-1',
                encodingVisible: true,
                template: '<div>' +
                    '<div ng-show="headerVisible"><div class="label">Header</div><input type="checkbox" ng-model="header"></div>' +
                    '<div ng-show="encoding && encodingVisible"><div class="label">Encoding</div><span>{{encoding}}</span></div>' +
                    '<div ng-show="separator && separatorVisible">' +
                    '<div class="label">Seperator</div>' +
                    '<span><input class="separator-input" type="text" ng-change="changeSeparator" ng-model="separator"><span>' +
                    '</div>' +
                    '<div><label class="btn btn-primary btn-lg" for="file-btn">Upload CSV</label><input class="cta hidden" name="file-btn" type="file" multiple accept="{{accept}}"/></div>' +
                    '</div>',
                accept: true
            };

            return options;
        }
    }
}());

'use strict';

var csvImport = angular.module('ngCsvImport', []);

csvImport.directive('ngCsvImport', function() {
	return {
		restrict: 'E',
		transclude: true,
		replace: true,
		scope:{
			content:'=?',
			header: '=?',
			headerVisible: '=?',
			separator: '=?',
			separatorVisible: '=?',
			result: '=?',
			encoding: '=?',
			encodingVisible: '=?',
			accept: '=?',
			callback: '=?'
		},
		template: '<div>'+
		  '<div ng-show="headerVisible"><div class="label">Header</div><input type="checkbox" ng-model="header"></div>'+
			'<div ng-show="encoding && encodingVisible"><div class="label">Encoding</div><span>{{encoding}}</span></div>'+
			'<div ng-show="separator && separatorVisible">'+
			'<div class="label">Seperator</div>'+
			'<span><input class="separator-input" type="text" ng-change="changeSeparator" ng-model="separator"><span>'+
			'</div>'+
			'<div><input class="btn cta gray" type="file" multiple accept="{{accept}}"/></div>'+
			'</div>',
		link: function(scope, element) {
			scope.separatorVisible = scope.separatorVisible || false;
			scope.headerVisible = scope.headerVisible || false;

			angular.element(element[0].querySelector('.separator-input')).on('keyup', function(e) {
				if ( scope.content != null ) {
					var content = {
						csv: scope.content,
						header: scope.header,
						separator: e.target.value,
						encoding: scope.encoding
					};
					scope.result = csvToJSON(content);
					scope.$apply();
					scope.callback(e);
				}
			});

			element.on('change', function(onChangeEvent) {
				var reader = new FileReader();
				scope.filename = onChangeEvent.target.files[0].name;
				reader.onload = function(onLoadEvent) {
					scope.$apply(function() {
						var content = {
							csv: onLoadEvent.target.result.replace(/\r\n|\r/g,'\n'),
							header: scope.header,
							separator: scope.separator
						};
						scope.content = content.csv;
						scope.result = csvToJSON(content);
						scope.result.filename = scope.filename;
						scope.$$postDigest(function(){
							scope.callback(onChangeEvent);
						});
					});
				};

				if ( (onChangeEvent.target.type === "file") && (onChangeEvent.target.files != null || onChangeEvent.srcElement.files != null) )  {
					reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0], scope.encoding);
				} else {
					if ( scope.content != null ) {
						var content = {
							csv: scope.content,
							header: !scope.header,
							separator: scope.separator
						};
						scope.result = csvToJSON(content);
						scope.$$postDigest(function(){
							scope.callback(onChangeEvent);
						});
					}
				}
			});

			var csvToJSON = function(content) {
				var lines=content.csv.split('\n');
				var result = [];
				var start = 0;
				var columnCount = lines[0].split(content.separator).length;

				var headers = [];
				if (content.header) {
					headers=lines[0].split(content.separator);
					start = 1;
				}

				for (var i=start; i<lines.length; i++) {
					var obj = {};
					var currentline=lines[i].split(new RegExp(content.separator+'(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
					if ( currentline.length === columnCount ) {
						if (content.header) {
							for (var j=0; j<headers.length; j++) {
								obj[headers[j]] = currentline[j];
							}
						} else {
							for (var k=0; k<currentline.length; k++) {
								obj[k] = currentline[k];
							}
						}
						result.push(obj);
					}
				}
				return result;
			};
		}
	};
});

(function() {
    'use strict';
    angular.module('addValueInput', []);
})();

(function() {
    'use strict';

    angular
        .module('addValueInput')
        .factory('addValueInput', addValueInput);

    //TODO esse service não aceita um objeto como retorno;
    function addValueInput() {

        return function(nameInput, text) {
            var input = angular.element("input[name='" + nameInput + "']")[0];

            if (input === undefined) {
                return;
            }

            var range;
            var scrollPostion = input.scrollTop;
            var position = 0;
            var browser = ((input.selectionStart || input.selectionStart == "0") ? "ff" : (document.selection ? "ie" : false));

            if (browser == "ie") {
                input.focus();
                range = document.selection.createRange();
                range.moveStart("character", -input.value.length);
                position = range.text.length;
            } else if (browser == "ff") {
                position = input.selectionStart;
            }

            var front = (input.value).substring(0, position);
            var back = (input.value).substring(position, input.value.length);
            input.value = front + text + back;

            position = position + text.length;

            if (browser == "ie") {
                input.focus();
                range = document.selection.createRange();
                range.moveStart("character", -input.value.length);
                range.moveStart("character", position);
                range.moveEnd("character", 0);
                range.select();
            } else if (browser == "ff") {
                input.selectionStart = position;
                input.selectionEnd = position;
                input.focus();
            }
            input.scrollTop = scrollPostion;
            angular.element(input).trigger('input');
        };
    }

})();

(function() {
  'use strict';
  angular
    .module('ArEmail')
    .factory('variavelService', variavelService);

  variavelService.$inject = ['$http', 'exception', 'API'];

  /*@ngInject*/
  function variavelService($http, exception, API) {

    var service = {
      getAll: getAll
    };

    return service;

    function getAll() {
      return $http.get(API + '/variavel/all')
        .then(function(response) {
          return response.data.result;
        });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('ArEmail')
    .factory('utilService', utilService);

  function utilService() {
    var service = {
      extractNameOfEmail: extractNameOfEmail,
      capitalizeFirstLetter: capitalizeFirstLetter,
      validateEmail: validateEmail
    };
    return service;

    function extractNameOfEmail(email) {
      return email.replace(/@[^@]+$/, '');
    }

    function capitalizeFirstLetter(string) {
      return string[0].toUpperCase() + string.slice(1);
    }

    function validateEmail(email) {
      var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    }

  }

})();

(function () {
    'use strict';
    angular
        .module('ArEmail')
        .factory('usuarioService', usuarioService);

    usuarioService.$inject = ['$http', '$location', 'exception', 'API', 'TOKEN'];

    /*@ngInject*/
    function usuarioService($http, $location, exception, API, TOKEN) {
        var service = {
            getAll: getAll,
            getOne: getOne,
            add: add,
            set: set,
            remove: remove,
            getEmail: getEmail,
            setPassword: setPassword
        };
        return service;

        function getAll() {
            return $http.get(API + '/usuario')
                .then(success);

        }

        function getOne(codUsuario) {
            return $http.get(API + '/usuario/' + codUsuario)
                .then(success);
        }

        function add(data) {
            return $http.post(API + '/usuario', data)
                .then(success);
        }

        function set(data) {
            return $http.put(API + '/usuario', data)
                .then(success);
        }

        function remove(codUsuario) {
            return $http.delete(API + '/usuario/' + codUsuario)
                .then(success);
        }

        // /usuario/email-valido/:codUsuario'
        function getEmail(codUsuario) {
            return $http.get(API + '/usuario/email-valido/' + codUsuario)
                .then(success);
        }

        function setPassword(data) {
            return $http.put(API + '/usuario/password/', data)
                .then(success);
        }

        function success(response) {
            return response.data.result;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('ArEmail')
        .controller('UsuarioController', UsuarioController);

    /** @ngInject */
    function UsuarioController($uibModal, toastr, $log, logger, exception, $q, usuarioService, empresaService, USER, SweetAlert, datatablesOption, $compile, $scope) {
        var vm = this;
        $('[data-toggle="popover"]').popover();
        $('[data-toggle="tooltip"]').tooltip();

        vm.tituloView = 'Tabela de Usuários';

        vm.dtOptions = datatablesOption.optionsBuilder().fromFnPromise(function () {
                return getAllUsuario();
        })
        .withOption('responsive', true)
		.withOption('createdRow', createdRow);
        datatablesOption.option(vm.dtOptions);

        vm.dtColumns = [
            datatablesOption.columnBuilder().newColumn('usu_codigo').withTitle('ID').withOption('responsivePriority', '-1'),
            datatablesOption.columnBuilder().newColumn('usu_nome').withTitle('Nome').withOption('responsivePriority', '0'),
            datatablesOption.columnBuilder().newColumn('usu_login').withTitle('Login').withOption('responsivePriority', '2'),
            datatablesOption.columnBuilder().newColumn('usu_status').withTitle('Status').withClass("text-center").withOption('responsivePriority', '3').renderWith(function (data, type, full) {
                switch (full.usu_status) {
                case 'A':
                    return '<span class="label label-default">Aguardando</span>';
                case 'B':
                    return '<span class="label label-danger">Bloqueado</span>';
                case 'L':
                    return '<span  class="label label-success">Liberado</span>';
                default:
                    return '<span class="label label-default">Aguardando</span>';
                }
            }),

            datatablesOption.columnBuilder().newColumn('usu_data_criacao').withTitle('Criado').withClass("text-center").withOption('responsivePriority', '4').renderWith(function (data, type, full) {
                return moment(full.usu_data_criacao).format('DD/MM/YYYY hh:mm:ss');
            }),
            datatablesOption.columnBuilder().newColumn(null).withTitle('Gerenciar').withClass("text-center").withOption('responsivePriority', '-1').notSortable().renderWith(actionsHtml)
        ];


        function getAllUsuario() {
            return usuarioService.getAll()
                .then(function (response) {
                    return response;
                })
                .catch(function (err) {
                    exception.error(err);
                });
        }

        vm.openModal = function (isAdding, codUsuarioSelected) {
            var saveUsuarioModalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/usuario/usuario-modal.html',
                controller: 'UsuarioModalController',
                controllerAs: 'usuarioModal',
                size: 'lg',
                resolve: {
                    codUsuarioSelected: function () {
                        return codUsuarioSelected;
                    },
                    isAdding: function () {
                        return isAdding;
                    }
                }
            });
            // Promisse sucess e reject quendo é fechado quando
            saveUsuarioModalInstance.result
                .then(function () {
                    reloadData();
                })
                .catch(function (e) {
                    $log.info('Modal dismissed at: ' + new Date() + e);
                });
        };

        vm.remove = function (codUsuario) {
            SweetAlert.swal({
                    title: "Exclusão?",
                    text: "Deseja excluir o usuário?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#ff4136",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        usuarioService.remove(codUsuario)
                            .then(function (response) {
                                reloadData();
                            }).catch(function (err) {
                                exception.error(err);
                            });
                    }
                });
        };

        //funções do dataTables
        vm.reloadData = reloadData;
        vm.dtInstance = {};

        function reloadData() {
            var resetPaging = true;
            vm.dtInstance.reloadData(callback, resetPaging);
        }

        function callback(json) {
            //console.log(json);
        }

        function actionsHtml(data, type, full, meta) {

            return '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body>' +
                '<a  id="" uib-dropdown-toggle dropdown-append-to>' +
                '    <i class="fa fa-cog fa-lg fa-fw"></i>' +
                '</a>' +
                '<ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu aria-labelledby="">' +
                '    <li>' +
                '        <a href="#" ng-click="usuario.openModal(false, ' + data.usu_codigo + ')">' +
                '            <i class="fa fa-pencil"></i>' +
                '            Editar' +
                '        </a>' +
                '    </li>' +
                '    <li>' +
                '        <a href="#" ng-click="usuario.remove(' + data.usu_codigo + ')">' +
                '            <i class="fa fa-trash"></i>' +
                '            Remover' +
                '        </a>' +
                '    </li>' +
                ' </ul>' +
                '</span>';
        }

        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('ArEmail')
        .controller('UsuarioModalController', UsuarioModalController);

    function UsuarioModalController($uibModalInstance, $log, usuarioService, empresaService, entidadeService, SweetAlert, codUsuarioSelected, isAdding, exception, USER) {
        $('[data-toggle="popover"]').popover();
        var vm = this;

        vm.isAdding = isAdding;
        vm.form = {};
        vm.form.email = {};
        vm.userNivel = USER.usu_nivel;
        //Edição do Form
        if (!isAdding) {
            vm.form.usu_codigo = codUsuarioSelected;
            usuarioService.getOne(codUsuarioSelected)
                .then(function (response) {
                    var usuario = response;
                    //Dados do usuario
                    console.log(usuario);
                    vm.entidadeByEmpresa(null, usuario.cod_ger_empresa);
                    vm.form = usuario;
                }).catch(function (err) {
                    exception.error(err);
                });
        }
        //Select Entidade

        empresaService.getAll()
            .then(function (response) {
                vm.selectEmpresa = response.map(function (select) {
                    return {
                        value: parseInt(select.emp_codigo),
                        name: select.emp_nome_fantasia
                    };
                });
            }).catch(function (err) {
                exception.error(err);
            });

        vm.entidadeByEmpresa = function (item, model) {
            entidadeService.getAllByEmpresa(model)
                .then(function (response) {
                    vm.selectEntidade = response.map(function (select) {
                        return {
                            value: parseInt(select.ent_codigo),
                            name: select.ent_nome_fantasia
                        };
                    });
                }).catch(function (err) {
                    exception.error(err);
                });
        };
        if (vm.userNivel <= 2) {
            vm.entidadeByEmpresa(null, USER.cod_ger_empresa);
        }
        //TODO remover depois
        vm.changeEmailValido = function () {
            if (isAdding) {
                vm.form.email.ema_smtp_auth_user = vm.form.email.ema_email;
            }
        };
        //TODO remover depois
        vm.changeTypeAuth = function (item, model) {

            var type = model ? model : undefined;

            switch (type) {
                //Gmail
            case 1:
                vm.form.email.ema_smtp_host = 'smtp.gmail.com';
                vm.form.email.ema_smtp_port = 465;
                vm.form.email.ema_smtp_type_auth = 2;
                break;
                //Hotmail
            case 2:
                vm.form.email.ema_smtp_host = 'smtp.live.com';
                vm.form.email.ema_smtp_port = 587;
                vm.form.email.ema_smtp_type_auth = 3;
                break;
                //Yahoo
            case 3:
                vm.form.email.ema_smtp_host = 'smtp.mail.yahoo.com';
                vm.form.email.ema_smtp_port = 465;
                vm.form.email.ema_smtp_type_auth = 2;
                break;
            default:
                vm.form.email.ema_smtp_host = '';
                vm.form.email.ema_smtp_port = null;
                vm.form.email.ema_smtp_type_auth = null;
                break;
            }
        };

        //Tipo de Usuário
        switch (USER.usu_nivel) {
        case 1:
            vm.selectTipoUsuario = [{
                value: 1,
                name: 'Usuário'
            }];
            break;
        case 2:
            vm.selectTipoUsuario = [{
                value: 1,
                name: 'Usuário'
            }, {
                value: 2,
                name: 'Gerente'
            }];
            break;
        case 3:
            vm.selectTipoUsuario = [{
                value: 1,
                name: 'Usuário'
            }, {
                value: 2,
                name: 'Gerente'
            }, {
                value: 3,
                name: 'Administrador'
            }, ];
            break;
        default:

        }

        //Status do Email do Usuario
        vm.selectStatusEmail = [{
            value: 'A',
            name: 'Aguardando Liberação',

        }, {
            value: 'B',
            name: 'Bloqueado'
        }, {
            value: 'L',
            name: 'Liberado'
        }];
        //Tipo de Autenticação
        //TODO remover depois
        vm.selectSmtpTypes = [{
            value: 1,
            name: 'Gmail'
        }, {
            value: 2,
            name: 'Outtook / Hotmail'
        }, {
            value: 3,
            name: "Yahoo"
        }, {
            value: 100,
            name: "Outros"
        }];
//TODO remover depois
        vm.selectSmtpTypeAuthentications = [{
            value: 1,
            name: 'Sem SSL'
        }, {
            value: 2,
            name: 'Com SSL'
        }, {
            value: 3,
            name: 'Com TLS'
        }];
//TODO remover depois
        vm.selectSmtpPorts = [{
            value: 25,
            name: '25'
        }, {
            value: 465,
            name: '465'
        }, {
            value: 587,
            name: '587'
        }];

        vm.saveUsuario = function () {
            var data = vm.form;
            switch (USER.usu_nivel) {
            case 1:
                data.cod_ger_adm = USER.cod_ger_adm;
                data.cod_ger_empresa = USER.cod_ger_empresa;
                data.cod_ger_entidade = USER.cod_ger_entidade;
                break;
            case 2:
                data.cod_ger_adm = USER.cod_ger_adm;
                data.cod_ger_empresa = USER.cod_ger_empresa;
                break;
            case 3:
                data.cod_ger_adm = USER.cod_ger_adm;
                break;
            }
            //Adição
            if (isAdding) {
                usuarioService.add(data)
                    .then(function (response) {
                        vm.form = {};
                        vm.form.email = {};
                        SweetAlert.swal({
                                title: "Adição",
                                text: "Usuário adicionado com sucesso!",
                                type: "success",
                                closeOnConfirm: true
                            },
                            function () {
                                $uibModalInstance.close();
                            });
                    }).catch(function (err) {
                        exception.error(err);
                    });
            } else {
                var tempUserLocal = angular.fromJson(localStorage.getItem('user'));
                tempUserLocal.usu_anexo_obrigatorio = data.usu_anexo_obrigatorio
                localStorage.setItem('user', angular.toJson(tempUserLocal))

                data.usu_codigo = codUsuarioSelected;
                //Edição
                delete data.usu_token;
                delete data.usu_permissao_acesso;
                if (!data.usu_password.length) {
                    delete data.usu_password;
                }

                usuarioService.set(data)
                    .then(function (response) {
                        SweetAlert.swal({
                                title: "Edição",
                                text: "Usuário alterado com sucesso!",
                                type: "success",
                                closeOnConfirm: true
                            },
                            function () {
                                $uibModalInstance.close();
                            });

                    }).catch(function (err) {
                        exception.error(err);
                    });
            }
        };

        //Limpa o Form
        vm.cleanForm = function () {
            vm.form = {};
            vm.form.email = {};
        };
    }

})();

(function() {
    'use strict';
    angular
        .module('ArEmail')
        .factory('modeloService', modeloService);

    modeloService.$inject = ['$http', 'API', 'TOKEN'];

    /*@ngInject*/
    function modeloService($http, API, TOKEN, variavelService) {
        var service = {
            getAll: getAll,
            getOne: getOne,
            add: add,
            set: set,
            remove: remove,
            getWithLimit: getWithLimit

        };

        return service;

        function getAll() {
            return $http.get(API + '/modelo', {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(function(response) {
                    return response.data.result;
                })
                .then(function(response) {
                    return response.map(function(element) {
                        element.mod_data_criacao = moment(element.mod_data_criacao).format('DD/MM/YYYY');
                        return element;
                    });
                });
        }

        function getOne(codModelo) {
            return $http.get(API + '/modelo/' + codModelo, {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(function(response) {
                    return response.data.result;
                });
        }

        function add(dataModelo) {
            return $http.post(API + '/modelo', dataModelo, {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(function(response) {
                    return response.data.result;
                });
        }

        function set(dataModelo) {
            return $http.put(API + '/modelo', dataModelo, {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(function(response) {
                    return response.data.result;
                });
        }

        function remove(codModelo) {
            return $http.delete(API + '/modelo/' + codModelo, {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(function(response) {
                    return response.data.result;
                });
        }

        function getWithLimit(limit) {
            return $http.get(API + '/modelo/limit/' + limit, {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(function(response) {
                    return response.data.result;
                })
                .then(function(response) {
                    return response.map(function(element) {
                        element.mod_data_criacao = moment(new Date(element.mod_data_criacao)).format('DD/MM/YYYY');
                        return element;
                    });
                });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('ArEmail')
        .controller('ModeloController', ModeloController);

    /** @ngInject */
    function ModeloController($uibModal, toastr, $log, logger, $q, $state, $stateParams, $compile, $scope, SweetAlert, datatablesOption, modeloService, variavelService, tinymceOption, addValueInput, exception) {
        var vm = this;
        $('[data-toggle="popover"]').popover();
        $('[data-toggle="tooltip"]').tooltip();
        vm.tituloView = 'Tabela de Modelos de E-mail';
        vm.tituloView2 = 'Novo Modelo';

        //Verifica se existe o codigo do Modelo no parametro para determinar se é uma adição ou edição
        vm.isAdding = !$state.params.codModelo ? true : false;

        switch ($state.current.name) {
            case 'modelos':
                $q.all(initFormNovoModelo(), getAllModelo()).then(function() {});
                break;
            case 'novo-modelo':
                // console.log(getVariaveis());
                $q.all(processVariavel()).then(function() {});
                break;
            case 'novo-modelo.edit':
                //TODO entender melhor o $stateParams
                edit($state.params.codModelo);
                $q.all(processVariavel()).then(function() {});
                break;

            default:
        }

        function getAllModelo() {
            return modeloService.getAll()
                .then(function(response) {
                    return response;
                })
                .catch(function(err) {
                    exception.error(err);
                });
        }

        function initFormNovoModelo() {
            vm.formModelo = {};
			vm.tituloView2 = 'Editar Novo Modelo';
        }


        vm.save = function() {
            if (vm.isAdding) {
                modeloService.add(vm.formModelo)
                    .then(function(response) {
                        SweetAlert.swal({
                                title: "Adição",
                                text: "Modelo adicionado com sucesso!",
                                type: "success",
                                closeOnConfirm: true
                            },
                            function() {
                                initFormNovoModelo();
                            });
                    })
                    .catch(function(err) {
                        exception.error(err);
                    });
            } else {
                $log.info(vm.formModelo);
                modeloService.set(vm.formModelo)
                    .then(function(response) {
                        SweetAlert.swal({
                                title: "Edição",
                                text: "Modelo alterado com sucesso!",
                                type: "success",
                                closeOnConfirm: true
                            },
                            function() {
                                edit(vm.formModelo.mod_codigo);
                            });
                    })
                    .catch(function(err) {
                        exception.error(err);
                    });
            }

        };

        vm.remove = function(codModelo) {
            SweetAlert.swal({
                    title: "Exclusão?",
                    text: "Deseja excluir o modelo?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#ff4136",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        modeloService.remove(codModelo)
                            .then(function(response) {
                                reloadDataTable();
                            })
                            .catch(function(err) {
                                exception.error(err);
                            });
                    }
                });
        };

        function edit(codModelo) {
            //é uma edição?
            if (!vm.isAdding) {
                modeloService.getOne(codModelo)
                    .then(function(response) {
                        vm.formModelo = {
                            mod_codigo: response.mod_codigo,
                            mod_name: response.mod_name,
                            mod_subject: response.mod_subject,
                            mod_content: response.mod_content
                        };
                    })
                    .catch(function(err) {
                        exception.error(err);
                    });
            }
        }


        vm.addVariavelSubject = function(nameInput, value) {
            addValueInput(nameInput, value);
        };

        function processVariavel() {
            variavelService.getAll()
                .then(function(response) {
                    //Subject
                    vm.variaveisSubject = response;
                    //Option do tynemce
                    tinymceOption.buildOptions.setup = function(editor) {
                        editor.addButton('varbutton', {
                            type: 'menubutton',
                            text: 'Variáveis',
                            icon: false,
                            menu: response.map(function(element) {
                                return {
                                    text: element.var_valor,
                                    onclick: function() {
                                        editor.insertContent(element.var_chave);
                                    }
                                };
                            })

                        });

                    };
                    vm.tinymceOptions = tinymceOption.buildOptions;
                });
        }




        vm.dtColumns = [
            datatablesOption.columnBuilder().newColumn('mod_codigo').withTitle('ID').withOption('responsivePriority', '-1'),
            datatablesOption.columnBuilder().newColumn('mod_name').withTitle('Nome').withOption('responsivePriority', '1'),
            datatablesOption.columnBuilder().newColumn('mod_data_criacao').withTitle('Criado').withClass("text-center").withOption('responsivePriority', '2'),
            datatablesOption.columnBuilder().newColumn(null).withTitle('Gerenciar').withClass("text-center").withOption('responsivePriority', '-1').notSortable().renderWith(actionsHtmlTable)
        ];

        vm.dtOptions = datatablesOption.optionsBuilder().fromFnPromise(function() {
                return getAllModelo();
            })
            .withOption('order', [0, 'desc'])
			.withOption('responsive', true)
            .withOption('createdRow', createdRowTable);

        datatablesOption.option(vm.dtOptions);

        function reloadDataTable() {
            var resetPaging = true;
            vm.dtInstance.reloadData(function(json) {}, resetPaging);
        }


        function actionsHtmlTable(data, type, full, meta) {

            return '<span uib-dropdown on-toggle="toggled(open)">' +
                '  <a href id="" uib-dropdown-toggle>' +
                '    <i class="fa fa-cog fa-lg fa-fw"></i>' +
                '  </a>' +
                '  <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu aria-labelledby="">' +
                '    <li>' +
                '      <a ui-sref="novo-modelo.edit({codModelo: ' + data.mod_codigo + '})">' +
                '        <i class="fa fa-edit fa-fw"></i>' +
                '        Editar' +
                '      </a>' +
                '    </li>' +
                '    <li>' +
                '      <a href="">' +
                '        <i class="fa fa-copy fa-fw"></i>' +
                '        * Duplicar' +
                '      </a>' +
                '    </li>' +
                '    <li>' +
                '      <a href ng-click="modelo.remove(' + data.mod_codigo + ')">' +
                '        <i class="fa fa-trash fa-fw"></i>' +
                '        Remover' +
                '      </a>' +
                '    </li>' +
                '  </ul>' +
                '</span>';
        }

        function createdRowTable(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }



    }
})();

(function () {
  'use strict';

  angular
    .module('ArEmail')
    .controller('MainController', MainController);

  function MainController($q, $log, exception, emailUnicoService, modeloService) {
    var vm = this;

    activate();

    function activate() {
      var promises = [getLastEmailUnico(), getLastModelo(), getTotais()];
      return $q.all(promises).then(function () {});
    }

    function getTotais() {
      emailUnicoService.getTotais()
        .then(function (response) {
          response.forEach(function (total) {
            switch (total.status) {
            case 'processados':
              vm.totalProcessados = total.total
              break;
            case 'enviados':
              vm.totalEnviados = total.total
              break;
            case 'entregues':
              vm.totalEntregues = total.total
              break;
            case 'lidos':
              vm.totalLidos  = total.total
              break;
            case 'erro':
              vm.totalErro = total.total
              break;
            default:

            }

          })
        })
    }

    function getLastEmailUnico() {
      emailUnicoService.getLast()
        .then(function (response) {
          vm.ema_uni_codigo = response.ema_uni_codigo;
          vm.to = response.ema_uni_name_to + ' <' + response.ema_uni_to + '>';
          vm.subject = response.ema_uni_subject;
          vm.lastStatus = response.lastStatus;
          vm.lastStatusFormat = response.lastStatusFormat;
          vm.ema_uni_data_criacao = response.ema_uni_data_criacao;
        })
        .catch(function (err) {
          exception.error(err);
        });
    }

    function getLastModelo() {
      modeloService.getWithLimit(3)
        .then(function (response) {
          vm.lastModelos = response;
        })
        .catch(function (err) {
          exception.error(err);
        });
    }

    angular.element('[data-toggle="popover"]').popover();

  }
})();

(function () {
  'use strict';
  angular
    .module('ArEmail')
    .controller('MailUnicoModalAttachmentsController', MailUnicoModalAttachmentsController);

  function MailUnicoModalAttachmentsController($uibModalInstance, $scope, pdfUrl) {
    var vm = this;
    $scope.pdfUrl = pdfUrl;
  }
})();

(function () {
  'use strict';
  angular
    .module('ArEmail')
    .factory('emailUnicoService', emailUnicoService);

  emailUnicoService.$inject = ['$http', '$httpParamSerializer', 'API', 'TOKEN', 'logger', 'Upload', '$timeout', '$window', 'FileSaver'];

  /*@ngInject*/
  function emailUnicoService($http, $httpParamSerializer, API, TOKEN, logger, Upload, $timeout, $window, FileSaver) {
    var service = {
      sendEmail: sendEmail,
      getAll: getAll,
      getAllPaginated: getAllPaginated,
      getOne: getOne,
      getLast: getLast,
      uploadAttachments: uploadAttachments,
      downloadAttachment: downloadAttachment,
      getAllLeads: getAllLeads,
      createLead: createLead,
      processEnvelopeToSend: processEnvelopeToSend,
      getTotais: getTotais
    };

    return service;

    function sendEmail(envelope) {
      return $http.post(API + '/email', envelope)
        .then(function (response) {
          return response.data.result;
        });
    }

    function getAll() {
      return $http.get(API + '/email/all')
        .then(function (response) {
          return response.data.result;
        })
        .then(function (response) {
          return formatEmailUnico(response);
        });
    }

    function getAllPaginated(paginationParams) {
      return $http.get(API + '/email/all/paginated/', {
          params: paginationParams
        })
        .then(function (response) {
          return {
            emailUnico: formatEmailUnico(response.data.result.emailUnico),
            pagination: response.data.result.pagination
          };
        });
    }

    function getOne(codEmail) {
      return $http.get(API + '/email/' + codEmail)
        .then(function (response) {
          return response.data.result;
        })
        .then(function (response) {
          return formatEmailUnico([response]);
        })
        .then(function (response) {
          return response.length ? response[0] : [];
        });
    }

    function getLast() {

      // getFileServer()
      //     .then(function (response) {
      //
      //         var blob = new Blob([response.data], {
      //             type: 'application/octet-stream'
      //         });
      //
      //         var fileName = response.headers('content-disposition').split('=')[1].replace(/"/g, '');
      //         //FileSaver.saveAs(blob, fileName);
      //     });

      return $http.get(API + '/email/last')
        .then(function (response) {
          return response.data.result;
        })
        .then(function (response) {
          return response ? formatEmailUnico([response]) : response;
        })
        .then(function (response) {
          return response ? response[0] : [];
        });
    }

    function uploadAttachments(files) {
      return Upload.upload({
          url: API + '/email/attachments',
          data: {
            file: files
          }
        })
        .then(function (response) {
          return $timeout(function () {
            return response.data.result;
          });
        });
    }

    function downloadAttachment(codEmailUnico, attachment) {
      return $http.get(API + '/email/attachments/' + codEmailUnico + '/' + attachment.uuidFilename, {
          responseType: 'arraybuffer'
        })
        .then(function (response) {
          var blob = '';
          var fileExt = attachment.uuidFilename.split('.').pop();

          if (fileExt == 'pdf') {
            blob = new Blob([response.data], {
              type: 'application/pdf'
            });
            var pdfUrl = URL.createObjectURL(blob);
            return pdfUrl;
          }
          blob = new Blob([response.data], {
            type: 'application/octet-stream'
          });

          FileSaver.saveAs(blob, attachment.originalFilename);
        });

    }

    function getAllLeads() {
      return $http.get(API + '/leads')
        .then(function (response) {
          return response.data;
        })
    }

    function createLead(newLead) {
      return $http.post(API + '/leads', newLead)
        .then(function (response) {
          return response.data;
        })
    }

    function getTotais() {
      return $http.get(API + '/email/totais')
        .then(function (response) {
          return response.data;
        })
    }

    function processEnvelopeToSend(envelopeRaw) {
      var newEnvelope = {
        nameTo: envelopeRaw.to[0].name,
        to: envelopeRaw.to[0].email,
        subject: envelopeRaw.subject,
        content: envelopeRaw.content,
        codModelo: envelopeRaw.modelo ? envelopeRaw.modelo.mod_codigo : null,
        attachments: envelopeRaw.attachments,
        etiquetas: envelopeRaw.etiquetas
      }
      return newEnvelope;
    }

    function formatEmailUnico(emailUnico) {

      if (emailUnico.length) {
        return emailUnico.map(function (element) {
          //   element.ema_uni_data_criacao = moment(new Date(element.ema_uni_data_criacao)).format('DD/MM/YYYY HH:mm:ss');
          switch (element.lastStatus.status) {
          case 'lido':
            element.lastStatusFormat = 'Lido em: ' + element.lastStatus.data;
            break;
          case 'entregue':
            element.lastStatusFormat = 'Entregue em: ' + element.lastStatus.data;
            break;
          case 'enviado':
            element.lastStatusFormat = 'Enviado em: ' + element.lastStatus.data;
            break;
          case 'erro':
            element.lastStatusFormat = 'Erro';
            break;
          case 'processado':
            element.lastStatusFormat = 'Processado';
            break;
          default:
          }
          return element;
        });
      } else {
        return [];
      }
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('ArEmail')
    .controller('MailUnicoController', MailUnicoController);

  function MailUnicoController($uibModal, toastr, $log, logger, $q, $stateParams, $state, $compile, $scope, $window, SweetAlert, datatablesOption, emailUnicoService, loginService, modeloService, utilService, etiquetasService, tinymceOption, exception, DTOptionsBuilder, DTColumnBuilder) {

    var vm = this;

    vm.saveEmail = saveEmail;
    vm.etiquetasFiltrar = '';

    // Métodos para ui-select
    vm.tagTransformLead = tagTransformLead;
    vm.validateEmail = validateEmail;
    vm.filterTable = filterTable;

    vm.changeContent = changeContent

    var dataFilterTable = {};
    dataFilterTable.cod_ger_etiqueta = '';

    vm.clear = function () {
      vm.cod_ger_etiqueta = undefined;
    };

    //TODO verificar se o $q.all é a única forma de transformar uma function em promise
    switch ($state.current.name) {
    case 'mail-unico':
      $q.all(getAllEtiquetas()).then(function () {});
      break;
    case 'info-mail-unico':
      $q.all(getInfoEmailUnico()).then(function () {});
      break;
    case 'novo-mail-unico':
      $q.all(initFormEmail()).then(function () {});
      break;
    default:
    }

    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip();
    vm.tituloView = 'Tabela de E-Mails Enviados';
    vm.tituloView2 = 'Novo Modelo';

    function tagTransformLead(newTag) {
      var name = utilService.extractNameOfEmail(newTag);
      name = utilService.capitalizeFirstLetter(name);

      var item = {
        name: name,
        email: newTag.toLowerCase()
      };
      return item;
    }

    function filterTable() {
      vm.dtInstance.rerender();
    }

    function validateEmail(item, model) {
      if (item.hasOwnProperty('isTag')) {
        if (!utilService.validateEmail(item.email)) {
          SweetAlert.swal("Aviso!", "O e-mail informado não parece válido", "warning");
          vm.formEmail.to = [];
        }
      }

      if (vm.formEmail.modelo) {
        changeContent(vm.formEmail.modelo);
      }
    }

    function getAllLeads() {
      return emailUnicoService.getAllLeads()
        .then(function (response) {
          vm.leads = response.map(function (element) {
            return {
              value: element.lea_codigo,
              name: element.lea_nome,
              email: element.lea_email
            };
          });
        });
    }

    function getAllEtiquetas() {
      etiquetasService.getAll()
        .then(function (response) {
          vm.etiquetas = response;
        });
    }

    function initFormEmail() {

      //Não esta duplicandoo conteudo
      if (!$stateParams.duplicate) {
        //carrega os selects
        getAllModelo().then(function () {});
        getAllLeads();
        getAllEtiquetas();

        vm.formEmail = {
          codEmailUnico: null,
          codModelo: null,
          to: [],
          subject: '',
          content: '',
          attachments: null,
          etiquetas: [],
          valid: true
        };

      } else {

        //FIXME isso ta estranho
        var content = $stateParams.duplicate.ema_uni_content;
        var newContent = content.slice(content.lastIndexOf('*}</div>')).replace('*}</div>', '');

        getAllModelo().then(function () {});

        vm.formEmail = {
          codEmailUnico: null,
          codModelo: $stateParams.duplicate.cod_ger_modelo,
          nameTo: $stateParams.duplicate.ema_uni_name_to,
          to: $stateParams.duplicate.ema_uni_to,
          subject: $stateParams.duplicate.ema_uni_subject,
          valid: true,
          attachments: null,
          content: newContent
        };
      }

    }

    function getAllEmailUnico() {
      return emailUnicoService.getAll()
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          exception.error(err);
        });
    }

    function getAllEmailUnicoPaginated(data) {
      return emailUnicoService.getAllPaginated(data)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          exception.error(err);
        });
    }

    function getInfoEmailUnico() {
      emailUnicoService.getOne($stateParams.codEmail)
        .then(function (response) {
          $log.info(response);
          vm.status = response.status;
          vm.emailInfo = {
            codEmailUnico: response.ema_uni_codigo,
            to: response.ema_uni_to,
            subject: response.ema_uni_subject,
            content: response.ema_uni_content,
            attachments: response.ema_uni_attachments ? response.ema_uni_attachments.attachments : null
          };

          return response.cod_ger_modelo ? modeloService.getOne(response.cod_ger_modelo) : null;

        })
        .then(function (responseModelo) {
          if (responseModelo) {
            vm.emailInfo.modelo = responseModelo.mod_name;
          }
        })
        .catch(function (err) {
          exception.error(err);
        });
    }

    //carrega selects dos modelos
    function getAllModelo() {
      return modeloService.getAll()
        .then(function (response) {
            vm.formEmail.modelos = response;
        });
    }

    function changeContent(modeloSelected) {

      var subjectProcessed = modeloSelected.mod_subject;
      var contentProcessed = modeloSelected.mod_content;

      if (vm.formEmail.to[0]) {
        subjectProcessed = subjectProcessed.replace(/\*\|NOME\|\*/gi, vm.formEmail.to[0].name);
        subjectProcessed = subjectProcessed.replace(/\*\|EMAIL\|\*/gi, vm.formEmail.to[0].email);

        contentProcessed = contentProcessed.replace(/\*\|NOME\|\*/gi, vm.formEmail.to[0].name);
        contentProcessed = contentProcessed.replace(/\*\|EMAIL\|\*/gi, vm.formEmail.to[0].email);
      }

      vm.formEmail.subject = subjectProcessed;
      vm.formEmail.content = contentProcessed;
    }

    function saveEmail() {
      // Verifica se a conta está parametrizada para envio obrigatório do anexo
      if (loginService.getUserData().usu_anexo_obrigatorio === 'S' && (!vm.attachments || !vm.attachments.length)) {
        SweetAlert.swal("Envio!", "É necessário anexar ao menos um arquivo para concluir o envio", "warning");
      } else {
        var newEnvelope = emailUnicoService.processEnvelopeToSend(vm.formEmail);

        // Insere um novo Lead que não existe na base de leads
        if (vm.formEmail.to[0].hasOwnProperty('isTag')) {
          var newLead = {
            lea_nome: vm.formEmail.to[0].name,
            lea_email: vm.formEmail.to[0].email
          };
          emailUnicoService.createLead(newLead)
            .then(function () {
              getAllLeads();
            });
        }
        // Verifica se existe anexo no corpo do email enviado;
        if (vm.attachments && vm.attachments.length) {
          // Envia arquivos para o servidor
          emailUnicoService.uploadAttachments(vm.attachments)
            .then(function (response) {
              newEnvelope.attachments = response;
              sendEmail(newEnvelope);
            });

        } else {
          sendEmail(newEnvelope);
        }
      }

    }

    function sendEmail(data) {
      emailUnicoService.sendEmail(data)
        .then(function () {
          SweetAlert.swal({
              title: "Envio",
              text: "Email enviado com sucesso",
              type: "success",
              closeOnConfirm: true
            },
            function () {
              $window.location.reload();
            });
        })
        .catch(function (err) {
          exception.error(err);
        });
    }

    vm.downloadAttachment = function (codEmailUnico, attachment) {
      // console.log(uuidFilename);
      emailUnicoService.downloadAttachment(codEmailUnico, attachment)
        .then(function (response) {
          if (response) {
            openModalAttachmentPdf(response)
          }
        })
        .catch(function (err) {
          exception.error(err);
        });
    };

    vm.tinymceOptions = tinymceOption.buildOptions;

    // Modal
    function openModalAttachmentPdf(pdfUrl) {
      var modalPdfInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/mail-unico/main-unico-attachments-modal.view.html',
        controller: 'MailUnicoModalAttachmentsController',
        controllerAs: 'mailUnicoModalAttachmentsCtrl',
        size: 'lg',
        resolve: {
          pdfUrl: function () {
            return pdfUrl;
          }
        }
      });
      // Promisse sucess e reject quendo é fechado quando
      //   modalPdfInstance.result
      //     .then(function () {
      //       reloadData();
      //     })
    }

    vm.dtOptions = DTOptionsBuilder
      .newOptions()
      .withFnServerData(getAllEmailUnicoFiltered)
      .withDataProp('data')
      .withOption('processing', true)
      .withOption('serverSide', true)
      .withOption('responsive', true)
      .withOption('order', [0, 'desc'])
      .withOption('createdRow', createdRowTable);

    vm.dtColumns = [
      datatablesOption.columnBuilder().newColumn('ema_uni_codigo').withTitle('ID').withOption('responsivePriority', '-1'),
      datatablesOption.columnBuilder().newColumn('ema_uni_to').withTitle('Para').withOption('responsivePriority', '0'),
      datatablesOption.columnBuilder().newColumn('ema_uni_subject').withTitle('Assunto').withOption('responsivePriority', '1'),
      datatablesOption.columnBuilder().newColumn('lastStatusFormat').withTitle('Status').withClass("text-center").withOption('responsivePriority', '2').notSortable(),
      datatablesOption.columnBuilder().newColumn('ema_uni_data_criacao').withTitle('Criado').withClass("text-center").withOption('responsivePriority', '3'),
      datatablesOption.columnBuilder().newColumn('emailEtiquetas').withTitle('Etiquetas').withClass("text-center").withOption('responsivePriority', '2').notSortable().renderWith(actionsColumnEtiquetas),
      datatablesOption.columnBuilder().newColumn(null).withTitle('Gerenciar').withClass("text-center").notSortable().withOption('responsivePriority', '-1').renderWith(actionsColumnGerenciar)
    ];

    function getAllEmailUnicoFiltered(sSource, aoData, fnCallback, oSetting) {
      dataFilterTable.cod_ger_etiqueta = vm.cod_ger_etiqueta || '';
      return emailUnicoServerData(sSource, aoData, fnCallback, oSetting, dataFilterTable)
    }

    function emailUnicoServerData(sSource, aoData, fnCallback, oSetting, dataFilterTable) {
      var draw = aoData[0].value;
      var columns = aoData[1].value;
      var order = aoData[2].value;
      var start = aoData[3].value;
      var length = aoData[4].value;
      var search = aoData[5].value;

      var paginationParams = {
        offset: start,
        limit: length,
        columnOrder: columns[order[0].column].data,
        columnOrderType: order[0].dir,
        searchTerm: search.value,
        dataFilterTable: dataFilterTable
      };

      getAllEmailUnicoPaginated(paginationParams)
        .then(function (reponse) {
          var records = {
            'draw': draw,
            'recordsTotal': reponse.pagination.rowCount,
            'recordsFiltered': reponse.pagination.rowCount,
            'data': reponse.emailUnico
          };
          fnCallback(records);
        });
    }

    datatablesOption.option(vm.dtOptions);

    vm.dtInstance = {};

    vm.reloadData = function () {
      vm.dtInstance.rerender();
    };

    function actionsColumnGerenciar(data, type, full, meta) {

      var objEmail = {
        codModelo: data.cod_ger_modelo,
        ema_uni_name_to: data.ema_uni_name_to,
        ema_uni_to: data.ema_uni_to,
        ema_uni_subject: data.ema_uni_subject,
        ema_uni_content: data.ema_uni_content
      };

      return '<span uib-dropdown on-toggle="toggled(open)"dropdown-append-to-body>' +
        '   <a href="#" id="" uib-dropdown-toggle>' +
        '       <i class="fa fa-cog fa-lg fa-fw"></i>' +
        '   </a>' +
        '   <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu aria-labelledby="">' +
        '   <li>' +
        '       <a ui-sref="info-mail-unico({codEmail: ' + data.ema_uni_codigo + '})">' +
        '           <i class="fa fa-eye fa-fw"></i>' +
        '           Visualizar' +
        '       </a>' +
        '   </li>' +
        // '   <li>' +
        // '       <a ui-sref="novo-mail-unico({duplicate: null })">' +
        // '           <i class="fa fa-copy fa-fw"></i>' +
        // '               * Duplicar' +
        // '       </a>' +
        // '   </li>' +
        '</ul>' +
        '</span>';
    }

    function actionsColumnEtiquetas(data, type, full, meta) {
      var etiquetasHtml = '';
      if (data.length) {
        data.forEach(function (etiqueta) {
          etiquetasHtml += '<span class="label" style="background-color:' + etiqueta.eti_cor + '">' + etiqueta.eti_nome + '</span><br>';
        });
      }
      return etiquetasHtml;
    }

    function createdRowTable(row, data, dataIndex) {
      // Recompiling so we can bind Angular directive to the DT
      $compile(angular.element(row).contents())($scope);
    }

    vm.removeAttachments = function (attachment) {
      vm.attachments.splice(vm.attachments.indexOf(attachment), 1);
      vm.attachments = vm.attachments.slice(0);
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('ArEmail')
    .factory('loginService', loginService);

  loginService.$inject = ['$http', 'logger', 'API'];

  /*@ngInject*/
  function loginService($http, logger, API) {
    var service = {
      authLogin: authLogin,
      getUserData: getUserData,
      recoveryPassword: recoveryPassword
    };
    return service;

    function authLogin(data) {
      return $http.post(API + '/login', data)
        .then(function (response) {
          return response.data;
        })
    }

    function recoveryPassword(dataEmailRecovery) {
      return $http.post(API + '/usuario/password-recovery', dataEmailRecovery)
        .then(function (response) {
          return response.data;
        })
        .catch(function () {
          logger.error('Aviso', 'Houve um problema na recuperação da senha');
        });
    }

    function getUserData() {
      return angular.fromJson(localStorage.getItem('user'));
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('ArEmail')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($timeout, webDevTec, toastr, $window, loginService, SweetAlert, exception) {
    var vm = this;
    vm.login = login;
    vm.recoveryPassword = recoveryPassword;

    function login() {
	  angular.element('#loginBtn').button('loading');	
      return loginService.authLogin({
          username: vm.username,
          password: vm.password
        })
        .then(function (response) {		  
		  
		  
          localStorage.setItem("user", JSON.stringify(response.user));
          localStorage.setItem("token", response.token);
          $timeout(function () {
            $window.location.href = '/home';
          }, 0);

        })
        .catch(function () {
          SweetAlert.swal("Aviso!", "Usuário ou Senha inválidos", "error");
		  angular.element('#loginBtn').button('reset');
        });
    }

    function recoveryPassword() {
      var dataEmailRecovery = {
        emailUserRecovery: vm.formUsersRecoveryPassword.emailUserRecovery
      };
      loginService.recoveryPassword(dataEmailRecovery)
        .then(function () {
          SweetAlert.swal({
              title: "Aviso!",
              text: "Uma nova senha foi enviada para o e-mail informado",
              type: "info",
              closeOnConfirm: true
            },
            function () {
              vm.formUsersRecoveryPassword = {};
              angular.element('#recuperar').collapse('toggle');
            });
        });
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('ArEmail')
    .controller('NovoCampoModalController', NovoCampoModalController);

  function NovoCampoModalController() { //$uibModalInstance) {

    var vm = this;
    angular.element('[data-toggle="popover"]').popover();



    //Limpa o Form
    vm.cleanForm = function() {
      vm.listaForm = {};
    };
  }


})();

(function() {
    'use strict';

    angular
        .module('ArEmail')
        .controller('ListaController', ListaController);

    /** @ngInject */
    function ListaController($uibModal, toastr, $log, logger, $q, $timeout, SweetAlert, DTOptionsBuilder, DTColumnDefBuilder, $parse, csvOption, variavelService) {
        var vm = this;
        $('[data-toggle="popover"]').popover();
        $('[data-toggle="tooltip"]').tooltip();

        vm.tituloView = 'Tabela de Listas de E-mail';

        vm.inputs = [];

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(10)
            .withDOM('lfrtip')
            .withBootstrap().withLanguage({
                "oPaginate": {
                    "sNext": "»",
                    "sPrevious": "«"
                }
            });
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3).notSortable()
        ];
        vm.dtColumnDefs2 = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3),
            DTColumnDefBuilder.newColumnDef(4).notSortable()
        ];
        vm.dtInstance = {};



        vm.csv = csvOption.buildOptions;

        vm.processCsv = function() {
            var collumnsCsv;
            $timeout(function() {
                vm.csv.result.forEach(function(element, index) {
                    if (index === 0) {
                        collumnsCsv = Object.keys(element);
                    }
                });
                vm.collumnsCsv = collumnsCsv;
                // variavelService
            });
            // variavelService.getAll()
            // .then(function(response) {
            //     vm.inputs = {};
            //     console.log(response);
            //     vm.variaveis = response.map(function(element) {
            //         return {
            //             value: element.var_codigo,
            //             name: element.var_valor,
            //             chave : element.var_chave
            //         };
            //     });
            // })
            // .catch(function(err) {
            //     console.error(err);
            // });
        };


        vm.resultadoInputs = {};

        vm.getColl = function() {
            console.log(vm.resultadoInputs);
        };


    }
})();

(function () {
  'use strict';
  angular
    .module('ArEmail')
    .factory('leadsService', leadsService);

  function leadsService($http, $location, exception, API) {
    var service = {
      getAll: getAll,
      getAllFromTable: getAllFromTable,
      getByCode: getByCode,
      create: create,
      update: update,
      remove: remove
    };
    return service;

    function getAll() {
      return $http.get(API + '/leads')
        .then(function (response) {
          return response.data;
        })
    }

    function getAllFromTable(sSource, aoData, fnCallback, oSetting) {
      var draw = aoData[0].value;
      var columns = aoData[1].value;
      var order = aoData[2].value;
      var start = aoData[3].value;
      var length = aoData[4].value;
      var search = aoData[5].value;

      var paginationParams = {
        offset: start,
        limit: length,
        columnOrder: columns[order[0].column].data,
        columnOrderType: order[0].dir,
        searchTerm: search.value
      };

      getAllPaginated(paginationParams)
        .then(function (response) {
          var records = {
            'draw': draw,
            'recordsTotal': response.pagination.rowCount,
            'recordsFiltered': response.pagination.rowCount,
            'data': response.leads
          };
          fnCallback(records);
        });
    }

    function getByCode(codLead) {
      return $http.get(API + '/leads/' + codLead)
        .then(function (response) {
          return response.data;
        })
    }

    function create(newLead) {
      return $http.post(API + '/leads', newLead)
        .then(function (response) {
          return response.data;
        })
    }

    function update(updatedLead) {
      return $http.put(API + '/leads', updatedLead)
        .then(function (response) {
          return response.data;
        })
    }

    function remove(codLead) {
      return $http.delete(API + '/leads/' + codLead)
        .then(function (response) {
          return response.data;
        })
    }

    function getAllPaginated(paginationParams) {
      return $http.get(API + '/leads/paginated', {
          params: paginationParams
        })
        .then(function (response) {
          return {
            leads: response.data.leads,
            pagination: response.data.pagination
          }
        })
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('ArEmail')
    .controller('LeadsController', LeadsController);

  function LeadsController($scope, $compile, $uibModal, leadsService, datatablesOption, DTOptionsBuilder, SweetAlert) {
    var vm = this;
    $('[data-toggle="popover"]').popover();
	vm.dtInstance = {};
    vm.openModal = openModal;
    vm.reloadData = reloadData;
    vm.remove = remove;

    vm.dtColumns = [
      datatablesOption.columnBuilder().newColumn('lea_codigo').withTitle('ID').withOption('responsivePriority', '-1'),
      datatablesOption.columnBuilder().newColumn('lea_nome').withTitle('Nome').withOption('responsivePriority', '0'),
      datatablesOption.columnBuilder().newColumn('lea_email').withTitle('E-mail').withOption('responsivePriority', '1'),
      datatablesOption.columnBuilder().newColumn(null).withTitle('Gerenciar').withClass("text-center").notSortable().withOption('responsivePriority', '-1').renderWith(actionsColunmGerenciar)
    ];

    vm.dtOptions = DTOptionsBuilder
      .newOptions()
      .withFnServerData(leadsService.getAllFromTable)
      .withDataProp('data')
      .withOption('processing', true)
      .withOption('serverSide', true)
      .withOption('responsive', true)
      .withOption('searching', false)
      .withOption('order', [0, 'desc'])
      .withOption('createdRow', createdRow);

    datatablesOption.option(vm.dtOptions);

    function reloadData() {
      vm.dtInstance.rerender();
    }

    function actionsColunmGerenciar(data, type, full, meta) {
      return '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body>' +
        '<a  id="" uib-dropdown-toggle dropdown-append-to>' +
        '    <i class="fa fa-cog fa-lg fa-fw"></i>' +
        '</a>' +
        '<ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu aria-labelledby="">' +
        '    <li>' +
        '        <a href="#" ng-click="leadsCtrl.openModal(false, ' + data.lea_codigo + ')">' +
        '            <i class="fa fa-pencil"></i>' +
        '            Editar' +
        '        </a>' +
        '    </li>' +
        '    <li>' +
        '        <a href="#" ng-click="leadsCtrl.remove(' + data.lea_codigo + ')">' +
        '            <i class="fa fa-trash"></i>' +
        '            Remover' +
        '        </a>' +
        '    </li>' +
        ' </ul>' +
        '</span>';
    }

    function createdRow(row, data, dataIndex) {
      // Recompiling so we can bind Angular directive to the DT
      $compile(angular.element(row).contents())($scope);
    }

    // Modal
    function openModal (isAdding, codLeadSelected) {
      var saveLeadModalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/leads/leads-modal.view.html',
        controller: 'LeadsModalController',
        controllerAs: 'leadsModalCtrl',
        size: 'lg',
        resolve: {
          codLeadSelected: function () {
            return codLeadSelected;
          },
          isAdding: function () {
            return isAdding;
          }
        }
      });
      // Promisse sucess e reject quendo é fechado quando
      saveLeadModalInstance.result
        .then(function () {
          reloadData();
        })
    }

    function remove (codLead) {
      SweetAlert.swal({
          title: "Exclusão?",
          text: "Deseja excluir o Lead/Contato?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ff4136",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (isConfirm) {
          if (isConfirm) {
            leadsService.remove(codLead)
              .then(function () {
                reloadData();
              })
          }
        });
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('ArEmail')
    .controller('LeadsModalController', LeadsModalController);

  function LeadsModalController($uibModalInstance, $log, SweetAlert, codLeadSelected, isAdding, leadsService) {
    $('[data-toggle="popover"]').popover();

    var vm = this;
    vm.cleanForm = cleanForm
    vm.saveLead = saveLead
    vm.isAdding = isAdding;
    vm.formLead = {};

    // Edição do Form
    if (!isAdding) {
      vm.formLead.usu_codigo = codLeadSelected;
      leadsService.getByCode(codLeadSelected)
        .then(function (response) {
          vm.formLead = response;
        })
    }

    function saveLead() {
      var dataLead = vm.formLead;

      //Adição
      if (isAdding) {
        leadsService.create(dataLead)
          .then(function () {
            vm.formLead = {};
            SweetAlert.swal({
                title: "Adição",
                text: "Lead/Contato adicionado com sucesso!",
                type: "success",
                closeOnConfirm: true
              },
              function () {
                $uibModalInstance.close();
              });
          })

      } else {
        leadsService.update(dataLead)
          .then(function () {
            SweetAlert.swal({
                title: "Edição",
                text: "Lead/Contato alterado com sucesso!",
                type: "success",
                closeOnConfirm: true
              },
              function () {
                $uibModalInstance.close();
              });
          })
      }
    }

    //Limpa o Form
    function cleanForm() {
      vm.formLead = {};
      vm.formLead.email = {};
    }
  }

})();

(function () {
  'use strict';

  angular.module('ArEmail')
    .factory('notFoundInterceptor', notFoundInterceptor);

  notFoundInterceptor.$inject = ['$q', '$location'];

  function notFoundInterceptor($q, $location) {
    return {
      responseError: function (response) {
        if (response.status === 401) {
          $location.path('/login');
        }
        return $q.reject(response);
      }
    };
  }
})();

(function () {
  'use strict';
  angular.module('ArEmail')
    .factory('authInterceptor', authInterceptor);

  authInterceptor.$inject = ['$q', '$location'];

  function authInterceptor($q, $location) {
    return {
      request: function (config) {
        config.headers = config.headers || {};
        if (localStorage.getItem('token')) {
          config.headers.Authorization = 'JWT ' + localStorage.getItem('token');
          config.headers.token = localStorage.getItem('token');
        }
        return config;
      },
      responseError: function (response) {
        if (response.status === 401 || response.status === 403) {
          $location.path('/login');
        }
        return $q.reject(response);
      }
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('ArEmail')
    .factory('etiquetasService', etiquetasService);

  function etiquetasService($http, $location, exception, API) {
    var service = {
      getAll: getAll,
      getAllFromTable: getAllFromTable,
      getByCode: getByCode,
      create: create,
      update: update,
      remove: remove
    };
    return service;

    function getAll() {
      return $http.get(API + '/etiquetas')
        .then(function (response) {
          return response.data;
        })
    }

    function getAllFromTable(sSource, aoData, fnCallback, oSetting) {
      var draw = aoData[0].value;
      var columns = aoData[1].value;
      var order = aoData[2].value;
      var start = aoData[3].value;
      var length = aoData[4].value;
      var search = aoData[5].value;

      var paginationParams = {
        offset: start,
        limit: length,
        columnOrder: columns[order[0].column].data,
        columnOrderType: order[0].dir,
        searchTerm: search.value
      };

      getAllPaginated(paginationParams)
        .then(function (response) {
          var records = {
            'draw': draw,
            'recordsTotal': response.pagination.rowCount,
            'recordsFiltered': response.pagination.rowCount,
            'data': response.etiquetas
          };
          fnCallback(records);
        });
    }

    function getByCode(codLead) {
      return $http.get(API + '/etiquetas/' + codLead)
        .then(function (response) {
          return response.data;
        })
    }

    function create(newLead) {
      return $http.post(API + '/etiquetas', newLead)
        .then(function (response) {
          return response.data;
        })
    }

    function update(updatedLead) {
      return $http.put(API + '/etiquetas', updatedLead)
        .then(function (response) {
          return response.data;
        })
    }

    function remove(codLead) {
      return $http.delete(API + '/etiquetas/' + codLead)
        .then(function (response) {
          return response.data;
        })
    }

    function getAllPaginated(paginationParams) {
      return $http.get(API + '/etiquetas/paginated', {
          params: paginationParams
        })
        .then(function (response) {
          return {
            etiquetas: response.data.etiquetas,
            pagination: response.data.pagination
          }
        })
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('ArEmail')
    .controller('EtiquetasController', EtiquetasController);

  function EtiquetasController($scope, $compile, $uibModal, etiquetasService, datatablesOption, DTOptionsBuilder, SweetAlert) {
    var vm = this;
	$('[data-toggle="popover"]').popover();
    vm.dtInstance = {};
    vm.openModal = openModal;
    vm.reloadData = reloadData;
    vm.remove = remove;

    vm.dtColumns = [
      datatablesOption.columnBuilder().newColumn('eti_codigo').withTitle('ID').withOption('responsivePriority', '-1'),
      datatablesOption.columnBuilder().newColumn('eti_nome').withTitle('Nome').withOption('responsivePriority', '0'),
      datatablesOption.columnBuilder().newColumn('eti_cor').withTitle('Cor').withClass("text-center").withOption('responsivePriority', '1').renderWith(actionsColunmCor),
      datatablesOption.columnBuilder().newColumn(null).withTitle('Gerenciar').withClass("text-center").notSortable().withOption('responsivePriority', '-1').renderWith(actionsColunmGerenciar)
    ];

    vm.dtOptions = DTOptionsBuilder
      .newOptions()
      .withFnServerData(etiquetasService.getAllFromTable)
      .withDataProp('data')
      .withOption('processing', true)
      .withOption('serverSide', true)
      .withOption('responsive', true)
      .withOption('searching', false)
      .withOption('order', [0, 'desc'])
      .withOption('createdRow', createdRow);

    datatablesOption.option(vm.dtOptions);

    function reloadData() {
      vm.dtInstance.rerender();
    }

    function actionsColunmGerenciar(data, type, full, meta) {
      return '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body>' +
        '<a  id="" uib-dropdown-toggle dropdown-append-to>' +
        '    <i class="fa fa-cog fa-lg fa-fw"></i>' +
        '</a>' +
        '<ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu aria-labelledby="">' +
        '    <li>' +
        '        <a href="#" ng-click="etiquetasCtrl.openModal(false, ' + data.eti_codigo + ')">' +
        '            <i class="fa fa-pencil"></i>' +
        '            Editar' +
        '        </a>' +
        '    </li>' +
        '    <li>' +
        '        <a href="#" ng-click="etiquetasCtrl.remove(' + data.eti_codigo + ')">' +
        '            <i class="fa fa-trash"></i>' +
        '            Remover' +
        '        </a>' +
        '    </li>' +
        ' </ul>' +
        '</span>';
    }
	  
	function actionsColunmCor(data, type, full, meta) {
      return '<i class="fa fa-square fa-2x fa-fw" style="color:'+ data +'">' +
        '	</i>';		
    }

    function createdRow(row, data, dataIndex) {
      // Recompiling so we can bind Angular directive to the DT
      $compile(angular.element(row).contents())($scope);
    }

    // Modal
    function openModal (isAdding, codEtiquetaSelected) {
      var saveEtiquetaModalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/etiquetas/etiquetas-modal.view.html',
        controller: 'EtiquetasModalController',
        controllerAs: 'etiquetasModalCtrl',
        size: 'lg',
        resolve: {
          codEtiquetaSelected: function () {
            return codEtiquetaSelected;
          },
          isAdding: function () {
            return isAdding;
          }
        }
      });
      // Promisse sucess e reject quendo é fechado quando
      saveEtiquetaModalInstance.result
        .then(function () {
          reloadData();
        });
    }

    function remove (codLead) {
      SweetAlert.swal({
          title: "Exclusão?",
          text: "Deseja excluir a Etiqueta?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ff4136",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (isConfirm) {
          if (isConfirm) {
            etiquetasService.remove(codLead)
              .then(function () {
                reloadData();
              })
          }
        });
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('ArEmail')
    .controller('EtiquetasModalController', EtiquetasModalController);

  function EtiquetasModalController($uibModalInstance, $log, SweetAlert, codEtiquetaSelected, isAdding, etiquetasService) {
    $('[data-toggle="popover"]').popover();

    var vm = this;
    vm.cleanForm = cleanForm;
    vm.saveEtiqueta = saveEtiqueta;
    vm.isAdding = isAdding;
    vm.formEtiqueta = {};

    // Opções do Color Picker
    vm.optionsColorPicker  = {
      required: true,
      format: 'hex',
	  //swatchOnly:true,
		swatchBootstrap:true,
    };

    // Edição do Form
    if (!isAdding) {
      etiquetasService.getByCode(codEtiquetaSelected)
        .then(function (response) {
          vm.formEtiqueta = response;
        });
    }

    function saveEtiqueta() {
      var dataEtiqueta = vm.formEtiqueta;

      //Adição
      if (isAdding) {
        etiquetasService.create(dataEtiqueta)
          .then(function () {
            vm.formEtiqueta = {};
            SweetAlert.swal({
                title: "Adição",
                text: "Etiqueta adicionada com sucesso!",
                type: "success",
                closeOnConfirm: true
              },
              function () {
                $uibModalInstance.close();
              });
          });

      } else {
        etiquetasService.update(dataEtiqueta)
          .then(function () {
            SweetAlert.swal({
                title: "Edição",
                text: "Etiqueta alterada com sucesso!",
                type: "success",
                closeOnConfirm: true
              },
              function () {
                $uibModalInstance.close();
              });
          });
      }
    }

    //Limpa o Form
    function cleanForm() {
      vm.formEtiqueta = {};
    }

  }

})();

(function () {
    'use strict';
    angular
        .module('ArEmail')
        .factory('entidadeService', entidadeService);

    entidadeService.$inject = ['$http', 'API', 'TOKEN', 'logger'];

    /*@ngInject*/
    function entidadeService($http, API, TOKEN, logger) {
        var service = {
            getAll: getAll,
            getAllByEmpresa: getAllByEmpresa,
            getOne: getOne,
            add: add,
            set: set,
            remove: remove
        };
        return service;

        function getAll() {
            return $http.get(API + '/entidade', {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(success);
        }

        function getAllByEmpresa(codEmpresa) {
            return $http.get(API + '/entidade-by-empresa/' + codEmpresa, {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(success);
        }

        function getOne(codEntidade) {
            return $http.get(API + '/entidade/' + codEntidade, {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(success);
        }

        function add(entidade) {
            return $http.post(API + '/entidade', entidade, {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(success);
        }

        function set(data) {
            return $http.put(API + '/entidade', data, {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(success);
        }

        function remove(codEntidade) {
            return $http.delete(API + '/entidade/' + codEntidade, {
                    headers: {
                        token: TOKEN
                    }
                })
                .then(success);
        }

        function success(response) {
            return response.data.result;
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('ArEmail')
        .controller('EntidadeController', EntidadeController);

    /** @ngInject*/
    function EntidadeController(entidadeService, empresaService, $uibModal, toastr, $log, logger, $q, SweetAlert, datatablesOption, exception, $compile, $scope,USER) {

        var vm = this;
        $('[data-toggle="popover"]').popover();
        $('[data-toggle="tooltip"]').tooltip();

        vm.tituloView = 'Lista de Entidades Cadastradas';

        vm.dtOptions = datatablesOption.optionsBuilder().fromFnPromise(function () {
                return getAllEntidades();
            })
            .withOption('createdRow', createdRow);
        datatablesOption.option(vm.dtOptions);

        vm.dtColumns = [
            datatablesOption.columnBuilder().newColumn('ent_codigo').withTitle('ID'),
            datatablesOption.columnBuilder().newColumn('ent_nome_fantasia').withTitle('Entidade'),
            datatablesOption.columnBuilder().newColumn('ent_cnpj').withTitle('CNPJ'),

        ];

        vm.usu_nivel = USER.usu_nivel;

        if (vm.usu_nivel >= 2) {
            vm.dtColumns.push(datatablesOption.columnBuilder().newColumn(null).withTitle('Gerenciar').withClass("dt-center").notSortable().renderWith(actionsHtml))
        }

        function getAllEntidades() {
            return entidadeService.getAll()
                .then(function (response) {
                    return response;
                })
                .catch(function (err) {
                    exception.error(err);
                });
        }

        vm.openModal = function (isAdding, codEntidadeSelected) {
            var saveEntidadeModalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entidades/entidade-modal.html',
                controller: 'EntidadeModalController',
                controllerAs: 'entidadeModal',
                size: 'lg',
                resolve: {
                    codEntidade: function () {
                        return codEntidadeSelected;
                    },
                    isAdding: function () {
                        return isAdding;
                    }
                }
            });
            // Promisse sucess e reject quendo é fechado quando
            saveEntidadeModalInstance.result
                .then(function () {
                    reloadData();
                })
                .catch(function (e) {
                    $log.info('Modal dismissed at: ' + new Date() + e);
                });
        };

        vm.remove = function (codEntidade) {
            SweetAlert.swal({
                    title: "Exclusão?",
                    text: "Deseja excluir a Entidade?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#ff4136",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        entidadeService.remove(codEntidade)
                            .then(function (response) {
                                reloadData();
                            }).catch(function (err) {
                                exception.error(err);
                            });
                    }
                });
        };

        //funções do dataTables
        vm.reloadData = reloadData;
        vm.dtInstance = {};

        function reloadData() {
            var resetPaging = true;
            vm.dtInstance.reloadData(callback, resetPaging);
        }

        function callback(json) {
            //console.log(json);
        }

        function actionsHtml(data, type, full, meta) {

            return '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body>' +
                '<a  id="" uib-dropdown-toggle dropdown-append-to>' +
                '    <i class="fa fa-cog fa-lg fa-fw"></i>' +
                '</a>' +
                '<ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu aria-labelledby="">' +
                '    <li>' +
                '        <a  ng-click="entidade.openModal(false, ' + data.ent_codigo + ')">' +
                '            <i class="fa fa-pencil"></i>' +
                '            Editar' +
                '        </a>' +
                '    </li>' +
                '    <li>' +
                '        <a ng-click="entidade.remove(' + data.ent_codigo + ')">' +
                '            <i class="fa fa-trash"></i>' +
                '            Remover' +
                '        </a>' +
                '    </li>' +
                ' </ul>' +
                '</span>';
        }

        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('ArEmail')
        .controller('EntidadeModalController', EntidadeModalController);

    function EntidadeModalController($uibModalInstance, $timeout, entidadeService, empresaService, SweetAlert, codEntidade, isAdding, exception, USER) {

        var vm = this;
        vm.isAdding = isAdding;
        vm.userNivel = USER.usu_nivel;
        //Verifica se o modal está Adicionando ou Editando

        //TODO refatorar

        if (!isAdding) {
            vm.formEntidade.ent_codigo = codEntidade;
            entidadeService.getOne(codEntidade)
                .then(function (response) {
                    vm.formEntidade = response;
                }).catch(function (err) {
                    exception.error(err);
                });

        }

        empresaService.getAll()
            .then(function (response) {
                vm.selectEmpresas = response.map(function (select) {
                    return {
                        value: parseInt(select.emp_codigo),
                        name: select.emp_nome_fantasia
                    };
                });
            })
            .catch(function (err) {
                exception.error(err);
            });

        //Salva a Pessoa verificando se está adicionando ou editando
        vm.saveEntidade = function () {
            if (isAdding) {
              switch (USER.usu_nivel) {
              case 1:
                  vm.formEntidade.cod_ger_adm = USER.cod_ger_adm;
                  vm.formEntidade.cod_ger_empresa = USER.cod_ger_empresa;
                  break;
              case 2:
                  vm.formEntidade.cod_ger_adm = USER.cod_ger_adm;
                  vm.formEntidade.cod_ger_empresa = USER.cod_ger_empresa;
                  break;
              case 3:
                  vm.formEntidade.cod_ger_adm = USER.cod_ger_adm;
                  break;
              }
                //Inserindo Pessoa
                entidadeService.add(vm.formEntidade)
                    .then(function (response) {

                        vm.formEntidade = {};
                        SweetAlert.swal({
                                title: "Adição",
                                text: "Entidade adicionado com sucesso!",
                                type: "success",
                                closeOnConfirm: true
                            },
                            function () {
                                $uibModalInstance.close();
                            });
                    }).catch(function (err) {
                        exception.error(err);
                    });
            } else {
                //Alterando
                entidadeService.set(vm.formEntidade)
                    .then(function (response) {
                        SweetAlert.swal({
                                title: "Edição",
                                text: "Informações alterada com sucesso!",
                                type: "success",
                                closeOnConfirm: true
                            },
                            function () {
                                $uibModalInstance.close();
                            });
                    }).catch(function (err) {
                        exception.error(err);
                    });
            }
        };

        //Limpa o Form
        vm.cleanForm = function () {
            vm.formEntidade = {};
        };

        vm.pequisaCep = function () {
            empresaService.getCep(vm.formEntidade.ent_cep)
                .then(function (data) {
                    vm.formEntidade.ent_complemento = data.complemento;
                    vm.formEntidade.ent_cidade = data.localidade;
                    vm.formEntidade.ent_endereco = data.logradouro;
                    vm.formEntidade.ent_uf = data.uf;
                    vm.formEntidade.ent_bairro = data.bairro;

                });
        };
    }

})();

(function () {
  'use strict';
  angular
    .module('ArEmail')
    .factory('empresaService', empresaService);

  empresaService.$inject = ['$http', 'API', 'TOKEN', 'logger'];

  /*@ngInject*/
  function empresaService($http, API, TOKEN, logger) {
    var service = {
      getAll: getAll,
      getOne: getOne,
      getCep: getCep,
      add: add,
      set: set,
      remove: remove
    };
    return service;

    function getAll() {
      return $http.get(API + '/empresa')
        .then(success);
    }

    function getOne(codEmpresa) {
      return $http.get(API + '/empresa/' + codEmpresa)
        .then(success);
    }

    function add(data) {
      return $http.post(API + '/empresa', data)
        .then(success);
    }

    function set(data) {
      return $http.put(API + '/empresa', data)
        .then(success);
    }

    function remove(codEmpresa) {
      return $http.delete(API + '/empresa/' + codEmpresa)
        .then(success);
    }

    function getCep(cep) {
      return $http.get('https://viacep.com.br/ws/' + cep + '/json/')
        .then(function (response) {
          return response.data;
        });
    }

    function success(response) {
      return response.data.result;
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('ArEmail')
        .controller('EmpresaController', EmpresaController);

    /** @ngInject */
    function EmpresaController($uibModal, toastr, $log, logger, $state, $q, empresaService, SweetAlert, exception, datatablesOption, $compile, $scope, USER) {
        var vm = this;

        $('[data-toggle="popover"]').popover();
        vm.tituloView = 'Tabela de Empresas';

        vm.dtColumns = [
            datatablesOption.columnBuilder().newColumn('emp_codigo').withTitle('ID'),
            datatablesOption.columnBuilder().newColumn('emp_nome_fantasia').withTitle('Nome'),
            datatablesOption.columnBuilder().newColumn('emp_cnpj').withTitle('CNPJ')
        ];
        vm.usu_nivel = USER.usu_nivel;

        if (vm.usu_nivel == 3) {
            vm.dtColumns.push(datatablesOption.columnBuilder().newColumn(null).withTitle('Gerenciar').withClass("dt-center").notSortable().renderWith(actionsHtml))
        }
        vm.dtOptions = datatablesOption.optionsBuilder().fromFnPromise(function () {
                return getAllEmpresa();
            })
            .withOption('createdRow', createdRow);
        datatablesOption.option(vm.dtOptions);

        function getAllEmpresa() {
            return empresaService.getAll()
                .then(function (response) {
                    return response;
                })
                .catch(function (err) {
                    exception.error(err);
                });
        }

        vm.openModal = function (isAdding, codEmpresaSelected) {
            var saveEmpresaModalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/empresa/empresa-modal.html',
                controller: 'EmpresaModalController',
                controllerAs: 'empresaModal',
                size: 'lg',
                resolve: {
                    codEmpresaSelected: function () {
                        return codEmpresaSelected;
                    },
                    isAdding: function () {
                        return isAdding;
                    }
                }
            });
            // Promisse sucess e reject quendo é fechado quando
            saveEmpresaModalInstance.result
                .then(function () {
                    reloadData();
                })
                .catch(function (e) {
                    $log.info('Modal dismissed at: ' + new Date() + e);
                });
        };

        vm.remove = function (codEmpresa) {
            SweetAlert.swal({
                    title: "Exclusão?",
                    text: "Deseja excluir empresa?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#ff4136",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        empresaService.remove(codEmpresa)
                            .then(function (response) {
                                reloadData();
                            }).catch(function (err) {
                                exception.error(err);
                            });
                    }
                });
        };

        //funções do dataTables
        vm.reloadData = reloadData;
        vm.dtInstance = {};

        function reloadData() {
            var resetPaging = true;
            vm.dtInstance.reloadData(callback, resetPaging);
        }

        function callback(json) {
            //console.log(json);
        }

        function actionsHtml(data, type, full, meta) {

            return '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body>' +
                '<a  id="" uib-dropdown-toggle dropdown-append-to>' +
                '    <i class="fa fa-cog fa-lg fa-fw"></i>' +
                '</a>' +
                '<ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu aria-labelledby="">' +
                '    <li>' +
                '        <a  ng-click="empresa.openModal(false, ' + data.emp_codigo + ')">' +
                '            <i class="fa fa-pencil"></i>' +
                '            Editar' +
                '        </a>' +
                '    </li>' +
                '    <li>' +
                '        <a ng-click="empresa.remove(' + data.emp_codigo + ')">' +
                '            <i class="fa fa-trash"></i>' +
                '            Remover' +
                '        </a>' +
                '    </li>' +
                ' </ul>' +
                '</span>';
        }

        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('ArEmail')
        .controller('EmpresaModalController', EmpresaModalController);

    function EmpresaModalController($uibModalInstance, $log, empresaService, SweetAlert, codEmpresaSelected, isAdding, exception, USER) {

        var vm = this;


        vm.isAdding = isAdding;

        vm.title = (vm.isAdding ? 'Nova Empresa' : 'Editar Empresa');
        vm.formEmpresa = {};
        $('[data-toggle="popover"]').popover();

        //Edição do Form
        if (!isAdding) {
            vm.formEmpresa.emp_codigo = codEmpresaSelected;
            empresaService.getOne(codEmpresaSelected)
                .then(function(response) {
                    var empresa = response;
                    //Dados da Empresa
                    vm.formEmpresa = empresa;
                }).catch(function(err) {
                    exception.error(err);
                });
        }
        vm.saveEmpresa = function() {
            vm.formEmpresa.cod_ger_administrador = USER.cod_ger_adm;
            if (isAdding) {

                empresaService.add(vm.formEmpresa)
                    .then(function(response) {
                        vm.formEmpresa = {};
                        SweetAlert.swal({
                                title: "Adição",
                                text: "Empresa adicionado com sucesso!",
                                type: "success",
                                closeOnConfirm: true
                            },
                            function() {
                                $uibModalInstance.close();
                            });
                    }).catch(function(err) {
                        exception.error(err);
                    });
            } else {

                empresaService.set(vm.formEmpresa)
                    .then(function(response) {
                        vm.formEmpresa = {};
                        SweetAlert.swal({
                                title: "Edição",
                                text: "Informações alterada com sucesso!",
                                type: "success",
                                closeOnConfirm: true
                            },
                            function() {
                                $uibModalInstance.close();
                            });
                    }).catch(function(err) {
                        exception.error(err);
                    });


            }
        }

        //Limpa o Form
        vm.cleanForm = function() {
            vm.formEmpresa = {};
        };
        vm.pequisaCep = function() {
            empresaService.getCep(vm.formEmpresa.emp_cep)
                .then(function(data) {
                    vm.formEmpresa.emp_complemento = data.complemento;
                    vm.formEmpresa.emp_cidade = data.localidade;
                    vm.formEmpresa.emp_endereco = data.logradouro;
                    vm.formEmpresa.emp_uf = data.uf;
                    vm.formEmpresa.emp_bairro = data.bairro;


                });
        };




        //fim
    }



})();

(function () {
    'use strict';

    angular
        .module('ArEmail')
        .controller('ConfiguracaoController', ConfiguracaoController);

    /** @ngInject */
    function ConfiguracaoController($q, SweetAlert, usuarioService, USER) {

        $('[data-toggle="popover"]').popover();
        $('[data-toggle="tooltip"]').tooltip();

        var vm = this;

        activate();

        function activate() {
            var promises = [initForm()];
            return $q.all(promises).then(function () {});
        }

        function initForm() {
            vm.usu_nome = USER.usu_nome;
            vm.usu_login = USER.usu_login;
            vm.oldPassword = '';
            vm.newPassword = '';
            vm.confirmPassword = '';
        }

        vm.setPassword = function () {

            usuarioService.setPassword({
                    oldPassword: vm.oldPassword,
                    newPassword: vm.newPassword
                })
                .then(function (response) {
                    if (response.success) {
                        SweetAlert.swal({
                                title: "Alteração de Senha",
                                text: "Senha alterada com sucesso!",
                                type: "success",
                                closeOnConfirm: true
                            },
                            function () {
                                initForm();
                            });
                    } else {
                        SweetAlert.swal({
                                title: "Alteração de Senha",
                                text: "Senha Atual não confere",
                                type: "error",
                                closeOnConfirm: true
                            },
                            function () {
                                initForm();
                            });
                    }
                })
                .catch(function (err) {
                    exception.error(err);
                });
        };

        //Configuração email
        vm.usuarioEmail = {};
        vm.usuarioEmail.form = {};
        vm.usuarioEmail.form.email = {};

        //Tipo de Autenticação


        usuarioService.getOne(USER.usu_codigo)
            .then(function (response) {
                var usuario = response;
                //Dados do usuario
                console.log(usuario);

                vm.usuarioEmail.form.email = usuario.email;
            }).catch(function (err) {
                exception.error(err);
            });
              vm.saveUsuarioEmail = function () {

                var data = {};
                  data.usu_codigo = USER.usu_codigo;
                  data.email = vm.usuarioEmail.form.email;


                  console.log(data);
                  usuarioService.set(data)
                      .then(function (response) {
                          SweetAlert.swal({
                                  title: "Edição",
                                  text: "Usuario adicionado com sucesso!",
                                  type: "success",
                                  closeOnConfirm: true
                              },
                              function () {
                                //  $uibModalInstance.close();
                              });

                      }).catch(function (err) {
                          exception.error(err);
                      });
              }

        vm.usuarioEmail.selectSmtpTypes = [{
            value: 1,
            name: 'Gmail'
        }, {
            value: 2,
            name: 'Outtook / Hotmail'
        }, {
            value: 3,
            name: "Yahoo"
        }, {
            value: 100,
            name: "Outros"
        }];
        vm.usuarioEmail.selectSmtpTypeAuthentications = [{
            value: 1,
            name: 'Sem SSL'
        }, {
            value: 2,
            name: 'Com SSL'
        }, {
            value: 3,
            name: 'Com TLS'
        }];

        vm.usuarioEmail.selectSmtpPorts = [{
            value: 25,
            name: '25'
        }, {
            value: 465,
            name: '465'
        }, {
            value: 587,
            name: '587'
        }];
        vm.usuarioEmail.changeEmailValido = function () {
            if (isAdding) {
                vm.usuarioEmail.form.email.ema_smtp_auth_user = vm.form.email.ema_email;
            }
        };
        vm.usuarioEmail.changeTypeAuth = function (item, model) {

            var type = model ? model : undefined;

            switch (type) {
                //Gmail
            case 1:
                vm.usuarioEmail.form.email.ema_smtp_host = 'smtp.gmail.com';
                vm.usuarioEmail.form.email.ema_smtp_port = 465;
                vm.usuarioEmail.form.email.ema_smtp_type_auth = 2;
                break;
                //Hotmail
            case 2:
                vm.usuarioEmail.form.email.ema_smtp_host = 'smtp.live.com';
                vm.usuarioEmail.form.email.ema_smtp_port = 587;
                vm.usuarioEmail.form.email.ema_smtp_type_auth = 3;
                break;
                //Yahoo
            case 3:
                vm.usuarioEmail.form.email.ema_smtp_host = 'smtp.mail.yahoo.com';
                vm.usuarioEmail.form.email.ema_smtp_port = 465;
                vm.usuarioEmail.form.email.ema_smtp_type_auth = 2;
                break;
            default:
                vm.usuarioEmail.form.email.ema_smtp_host = '';
                vm.usuarioEmail.form.email.ema_smtp_port = null;
                vm.usuarioEmail.form.email.ema_smtp_type_auth = null;
                break;
            }
        };
    }

})();

(function () {
	'use strict';

	angular
		.module('ArEmail')
		.controller('CampanhasController', CampanhasController);

	/** @ngInject */
	function CampanhasController($uibModal, toastr, $log, logger, $q, SweetAlert, DTOptionsBuilder, DTColumnDefBuilder) {
		var vm = this;

		vm.isCollapsed = false;

		angular.element('[data-toggle="popover"]').popover();

		vm.tituloView = 'Tabela de Campanhas';

		vm.dtOptions = DTOptionsBuilder.newOptions()
			.withPaginationType('full_numbers')
			.withDisplayLength(10)
			.withDOM('lfrtip')
			.withBootstrap().withLanguage({
				"oPaginate": {
					"sNext": "»",
					"sPrevious": "«"
				}
			});

		vm.dtColumnDefs = [
			DTColumnDefBuilder.newColumnDef(0),
			DTColumnDefBuilder.newColumnDef(1),
			DTColumnDefBuilder.newColumnDef(2),
			DTColumnDefBuilder.newColumnDef(3).notSortable()
		];

		vm.enviarCampanha = function () {
			SweetAlert.swal({
				title: "Confirmação de Envio",
				text: "<h3>Sua Campanha Possui</h3><h4><strong>1500 E-mails</strong></h4>",
				html: true,
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#28b62c",
				confirmButtonText: "Sim",
				cancelButtonText: "Não",
				closeOnConfirm: false,
				closeOnCancel: false
			}, function (isConfirm) {

				if (isConfirm) {
					SweetAlert.swal("Enviando!", "Campanha sendo enviada :)", "success");
				} else {
					SweetAlert.swal("Cancelado", "Campanha não enviada :)", "error");
				}
			});

		};

	}
})();

(function() {
  'use strict';

  angular
    .module('ArEmail')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function () {
  'use strict';
  angular
    .module('ArEmail')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, TOKEN, USER) {
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');

    $httpProvider.interceptors.push('notFoundInterceptor');
    $httpProvider.interceptors.push('authInterceptor');

    $stateProvider
      .state('login', {
        url: '/',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'login'
      });
    $stateProvider
      .state('logout', {
        url: '/logout',
        resolve: {
          logout: function ($location) {
            localStorage.clear();
            $location.path("/");
          }
        }
      });
    $stateProvider
      .state('home', {
        url: '/home',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        resolve: {
          auth: authencation()
        },
      });
    // $stateProvider
    //   .state('emailUnico', {
    //     url: '/testes/email-unico',
    //     templateUrl: 'app/testes/email-unico/email-unico.html',
    //     controller: 'EmailUnicoController',
    //     controllerAs: 'emailUnico',
    //     resolve: {
    //       auth: function(TOKEN, $location) {
    //         if (TOKEN) {
    //           console.log('true');
    //         } else {
    //           $location.path("/");
    //         }
    //       }
    //     },
    //   });
    $stateProvider
      .state('csv', {
        url: '/testes/csv',
        templateUrl: 'app/testes/csv/csv.html',
        controller: 'CsvController',
        controllerAs: 'csv',
        resolve: {
          auth: authencation()
        },
      });
    $stateProvider
      .state('tinymce', {
        url: '/testes/tinymce',
        templateUrl: 'app/testes/tinymce/tinymce.html',
        controller: 'TinyMceController',
        controllerAs: 'tiny',
        resolve: {
          auth: authencation()
        },
      });
    $stateProvider
      .state('datatable', {
        url: '/testes/datatable',
        templateUrl: 'app/testes/datatables/datatable.html',
        controller: 'DataTableController',
        controllerAs: 'datatable',
        resolve: {
          auth: authencation()
        },
      });
    $stateProvider
      .state('empresa', {
        url: '/cadastro/empresa',
        templateUrl: 'app/empresa/empresa.html',
        controller: 'EmpresaController',
        controllerAs: 'empresa',
        resolve: {
          permissao: permissao(2),
          auth: authencation()
        },
      });

    $stateProvider
      .state('entidade', {
        url: '/cadastro/entidades',
        templateUrl: 'app/entidades/entidade.html',
        controller: 'EntidadeController',
        controllerAs: 'entidade',
        resolve: {
          permissao: permissao(2),
          auth: authencation()
        },
      });

    $stateProvider
      .state('usuario', {
        url: '/cadastro/usuario',
        templateUrl: 'app/usuario/usuario.html',
        controller: 'UsuarioController',
        controllerAs: 'usuario',
        resolve: {
          auth: authencation()
        },
      });

    $stateProvider
      .state('campanhas', {
        url: '/campanhas/campanhas',
        templateUrl: 'app/campanhas/campanhas.html',
        controller: 'CampanhasController',
        controllerAs: 'campanhas',
        resolve: {
          auth: authencation()
        },
      });
    $stateProvider
      .state('criar-campanhas', {
        url: '/campanhas/criar-campanhas',
        templateUrl: 'app/campanhas/criar-campanhas.html',
        controller: 'CampanhasController',
        controllerAs: 'campanhas',
        resolve: {
          auth: authencation()
        },
      });
    $stateProvider
      .state('info-campanhas', {
        url: '/campanhas/info-campanhas',
        templateUrl: 'app/campanhas/info-campanhas.html',
        controller: 'CampanhasController',
        controllerAs: 'campanhas',
        resolve: {
          auth: authencation()
        },
      });

    $stateProvider
      .state('lista', {
        url: '/campanhas/lista',
        templateUrl: 'app/lista/lista.html',
        controller: 'ListaController',
        controllerAs: 'lista',
        resolve: {
          auth: authencation()
        },
      });

    $stateProvider
      .state('criar-lista', {
        url: '/campanhas/criar-lista',
        templateUrl: 'app/lista/criar-lista.html',
        controller: 'ListaController',
        controllerAs: 'lista',
        resolve: {
          auth: authencation()
        },
      });

    $stateProvider
      .state('modelos', {
        url: '/campanhas/modelos',
        templateUrl: 'app/modelos/modelos.html',
        controller: 'ModeloController',
        controllerAs: 'modelo',
        resolve: {
          auth: authencation()
        },
      });
    $stateProvider
      .state('novo-modelo', {
        url: '/campanhas/novo-modelo',
        templateUrl: 'app/modelos/novo-modelo.html',
        controller: 'ModeloController',
        controllerAs: 'modelo',
        resolve: {
          auth: authencation()
        },
      })
      .state('novo-modelo.edit', {
        url: '/:codModelo'
      });

    $stateProvider
      .state('mail-unico', {
        url: '/mail-unico/mail-unico',
        templateUrl: 'app/mail-unico/mail-unico.html',
        controller: 'MailUnicoController',
        controllerAs: 'mailUnico',
        resolve: {
          auth: authencation()
        },
      });

    $stateProvider
      .state('novo-mail-unico', {
        url: '/mail-unico/novo-mail-unico',
        params: {
          duplicate: ''
        },
        templateUrl: 'app/mail-unico/novo-mail-unico.html',
        controller: 'MailUnicoController',
        controllerAs: 'mailUnico',
        resolve: {
          auth: authencation()
        },
      });

    $stateProvider
      .state('info-mail-unico', {
        url: '/mail-unico/info-mail-unico/:codEmail',
        templateUrl: 'app/mail-unico/info-mail-unico.html',
        controller: 'MailUnicoController',
        controllerAs: 'mailUnico',
        resolve: {
          auth: authencation()
        },
      });

    $stateProvider
      .state('configuracao', {
        url: '/configuracao',
        templateUrl: 'app/configuracao/configuracao.html',
        controller: 'ConfiguracaoController',
        controllerAs: 'configuracao',
        resolve: {
          auth: authencation()
        },
      });

    $stateProvider
      .state('leads', {
        url: '/leads',
        templateUrl: 'app/leads/leads.view.html',
        controller: 'LeadsController',
        controllerAs: 'leadsCtrl',
        resolve: {
          auth: authencation()
        }
      });
      $stateProvider
        .state('etiquetas', {
          url: '/etiquetas',
          templateUrl: 'app/etiquetas/etiquetas.view.html',
          controller: 'EtiquetasController',
          controllerAs: 'etiquetasCtrl',
          resolve: {
            auth: authencation()
          }
        });

    function authencation() {
      return ['$location', function ($location) {
        if (TOKEN) {
          console.log('true');
        } else {
          $location.path("/");
        }
      }];
    }

    function permissao(nivel) {
      return ['SweetAlert', function (SweetAlert) {
        console.log(USER);
        if (USER.usu_nivel <= nivel - 1) {
          SweetAlert.swal({
              title: "Permissão",
              text: "Você não tem permissão para acessar essa área",
              type: "warning",
              confirmButtonColor: "#ff4136",
              confirmButtonText: "Ok",
              closeOnConfirm: false
            },
            function () {
              window.location.href = '/home';
            });
        }
      }];
    }

  }

})();

(function () {
  angular.module("ArEmail")
    .constant("API", "http://rev.ar-email.com.br:3005/api");
})();

(function () {
	'use strict';

	angular
		.module('ArEmail')
		.constant('malarkey', malarkey)
		.constant('moment', moment)
		.constant('TOKEN', localStorage.getItem("token"))
		.constant('USER', JSON.parse(localStorage.getItem("user")))
})();

(function() {
  'use strict';

  angular
    .module('ArEmail')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("ArEmail").run(["$templateCache", function($templateCache) {$templateCache.put("app/campanhas/campanhas.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid animated fadeIn\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"text-primary fa fa-home text-muted\"></i></a> <a href=# class=\"btn btn-default\"><span class=text-muted>Campanhas</span></a> <a href=# class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Minhas Campanhas</span></a></div><div class=page-header><h2>Minhas Campanhas <button class=\"pull-right popover-help btn-link animated pulse infinete\" data-toggle=popover title=\"Minhas Campanhas\" data-trigger=hover data-content=\"Campanhas de e-mail já realizadas. Para adição de nova campanha, utilize o botão Criar Campanha, para visualização das informações de campanhas já realizadas, clique no título da campanha ou utilize a opção Informações no menu da grade\" data-placement=left data-container=body><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><div class=\"panel panel-default h-no-margin\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">{{campanhas.tituloView}}</h3><a class=\"btn btn-primary btn-xs pull-right\" href=/campanhas/criar-campanhas>Criar Campanha</a><div class=clearfix></div></div></div><div class=table-resposive><table datatable=\"\" dt-options=campanhas.dtOptions dt-column-defs=campanhas.dtColumnDefs class=\"table table-striped table-hover table-bordered\"><thead><tr><th class=text-primary>ID</th><th class=text-primary>Nome</th><th class=\"text-center text-primary\">Enviado</th><th class=\"text-center text-primary\">Gerenciar</th></tr></thead><tbody><tr><td>1</td><td>Welinton</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr><tr><td>2</td><td>Rafael</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=/campanhas/info-campanhas><i class=\"fa fa-info fa-fw\"></i> Informações</a></li><li><a href><i class=\"fa fa-trash fa-fw\"></i> Remover</a></li></ul></span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/campanhas/criar-campanhas.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid animated fadeIn\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"text-primary fa fa-home text-muted\"></i></a> <a href=# class=\"btn btn-default\"><span class=text-muted>Campanhas</span></a> <a href=/campanhas/campanhas class=\"btn btn-default\"><span class=text-muted>Minhas Campanhas</span></a> <a href=# class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Criar Campanha</span></a></div><div class=page-header><h2>Criar Campanha <button class=\"pull-right popover-help btn-link animated pulse infinete\" data-toggle=popover title=\"Minhas Campanhas\" data-content=\"Para criação de uma nova campanha escolha um modelo de e-mail e uma lista de e-mails já cadastrados anteriormente, dê um nome a sua campanha e clique em Enviar Campanha.\" data-placement=left data-container=body data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><form><div class=row><div class=col-xs-12><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nome <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input type=text class=form-control></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Modelo de E-mail <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><select class=form-control></select></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Lista de E-mail <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><select class=form-control></select></div></div><div class=\"col-xs-12 text-center\"><div class=form-group><span class=\"fa-stack fa-5x\"><i class=\"fa fa-circle fa-stack-2x text-muted\"></i> <i class=\"fa fa-paper-plane fa-stack-1x fa-inverse\"></i></span></div><button type=button class=\"btn btn-primary btn-lg\" ng-click=campanhas.enviarCampanha()>Enviar Campanha</button></div></div></form></div><script>$(\'[data-toggle=\"popover\"]\').popover();\n  $(\'[data-toggle=\"tooltip\"]\').tooltip();</script>");
$templateCache.put("app/campanhas/info-campanhas.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i></a> <a href=# class=\"btn btn-default\"><span class=text-muted>Campanhas</span></a> <a href=/campanhas/campanhas class=\"btn btn-default\"><span class=text-muted>Minhas Campanhas</span></a> <a href=# class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Informações da Campanha</span></a></div><div class=page-header><h2>Informações da Campanha <button class=\"pull-right popover-help text-muted btn-link animated pulse infinete\" data-toggle=popover title=\"Informações da Campanha\" data-content=\"Dados de entregabilidade da campanha por status de envio. Para maior detalhamento, clique em Ver estatísticas detalhadas onde serão exibidas as informações completas por e-mail.\" data-placement=left data-container=body data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=\"col-xs-12 col-sm-8\"><div class=form-group><label class=label-control>Nome</label><input type=text class=form-control value=\"blabla bla\" readonly></div></div><div class=\"col-xs-12 col-sm-4\"><div class=form-group><label class=label-control>Enviado em</label><input type=text class=form-control value=\"blabla bla\" readonly></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Modelo de E-mail</label><input type=text class=form-control value=\"blabla bla\" readonly></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Lista de E-mail</label><input type=text class=form-control value=\"blabla bla\" readonly></div></div><div class=col-xs-12><div class=page-header><h3>Estatística</h3></div><div class=row><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"well well-small text-center\"><div class=row><div class=\"col-xs-12 col-sm-4 text-center\"><i class=\"fa fa-paper-plane fa-4x text-primary animated flipInY anime-0-6s\"></i></div><div class=\"col-xs-12 col-sm-8 text-center\"><h4 class=text-muted>Enviados</h4><h3>1500</h3></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"well well-small text-center\"><div class=row><div class=\"col-xs-12 col-sm-4 text-center\"><i class=\"fa fa-check fa-4x text-success animated flipInY anime-0-8s\"></i></div><div class=\"col-xs-12 col-sm-8 text-center\"><h4 class=text-muted>Entregues</h4><h3>1480</h3></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"well well-small text-center\"><div class=row><div class=\"col-xs-12 col-sm-4 text-center\"><i class=\"fa fa-folder-open fa-4x text-warning animated flipInY anime-1s\"></i></div><div class=\"col-xs-12 col-sm-8 text-center\"><h4 class=text-muted>Taxa de Abertura</h4><h3>149 <small>(10%)</small></h3></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"well well-small text-center\"><div class=row><div class=\"col-xs-12 col-sm-4 text-center\"><i class=\"fa fa-exclamation-triangle fa-4x text-danger animated flipInY anime-1-2s\"></i></div><div class=\"col-xs-12 col-sm-8 text-center\"><h4 class=text-muted>Erro na Entrega</h4><h3>15</h3></div></div></div></div><div class=col-xs-12><div class=text-right><button type=button class=\"btn btn-link\" ng-click=\"isCollapsed = !isCollapsed\">Estatísticas Detalhadas</button></div><div uib-collapse=!isCollapsed><div class=page-header><h3>Estatística Detalhadas <button class=\"pull-right popover-help text-muted btn-link\" data-toggle=popover title=\"Estatísticas Detalhadas\" data-content=\"Estatísticas detalhadas por e-mail. Utilize as abas para filtrar os e-mails por status, ou utilize o campo de pesquisa para busca por e-mail específico.\" data-placement=left data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h3></div><uib-tabset active=activeJustified justified=true><uib-tab index=0 heading=Todos>Justified content</uib-tab><uib-tab index=1 heading=Enviados>Short Labeled Justified content</uib-tab><uib-tab index=2 heading=Entregues>Long Labeled Justified content</uib-tab><uib-tab index=3 heading=\"Taxa de Abertura\">Long Labeled Justified content</uib-tab><uib-tab index=4 heading=\"Erro na Entrega\">Long Labeled Justified content</uib-tab></uib-tabset></div></div></div></div></div></div>");
$templateCache.put("app/configuracao/configuracao.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=/configuracao class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Configurações</span></a></div><div class=page-header><h2>Configuração <button class=\"pull-right popover-help text-muted btn-link animated pulse infinete\" data-toggle=popover title=Configuração data-content=\"Exibição das informações do usuário. Para alteração de senha, insira a senha atual, a senha nova e repita a senha nova. A troca da senha ocorrerá após o clique no botão Salvar onde será desconectado para entrada com nova senha.\" data-placement=left data-container=body data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><ul class=\"nav nav-tabs\" role=tablist><li role=presentation class=active><a href=#config-dados aria-controls=home role=tab data-toggle=tab>Dados Pessoais</a></li><li role=presentation><a href=#config-email aria-controls=profile role=tab data-toggle=tab>Configuração de Email</a></li></ul><!-- Tab panes --><div class=\"tab-content tab-content-default\"><div role=tabpanel class=\"tab-pane fade in active\" id=config-dados><form ng-submit=configuracao.setPassword()><div class=row><div class=col-xs-12><h3>Dados Pessoais</h3><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nome do Usuário</label><input class=form-control type=text readonly disabled ng-model=configuracao.usu_nome tabindex=1></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Login</label><input class=form-control type=text readonly disabled ng-model=configuracao.usu_login tabindex=2></div><h3>Senha</h3><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Senha Atual <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input class=form-control type=password required ng-model=configuracao.oldPassword tabindex=3></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nova Senha <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input class=form-control type=password required ng-model=configuracao.newPassword tabindex=4></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Repetir Nova Senha <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input class=form-control type=password required ng-model=configuracao.confirmPassword tabindex=5></div><div class=form-group><button type=submit class=\"btn btn-primary btn-lg pull-right\">Salvar</button><div class=clearfix></div></div></div></div></form></div><div role=tabpanel class=\"tab-pane fade\" id=config-email><form ng-submit=configuracao.saveUsuarioEmail()><div class=page-header><h3 class=text-muted>Configuração de E-mail</h3></div><div class=form-group ng-if=false><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Codigo Email <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=ema_email type=text class=form-control ng-model=configuracao.usuarioEmail.form.email.ema_codigo required></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nome Remetente <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button tabindex=-1 class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=\"Nome Remetente\" data-content=\"O nome que irá compor o cabeçalho do e-mail como responsável pelo envio. O nome do Remetente pode ser o mesmo que o Nome do usuário.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button> <input name=ema_email type=text class=form-control ng-model=configuracao.usuarioEmail.form.email.ema_nome required></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">E-mail Válido <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button tabindex=-1 class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=\"E-mail Válido\" data-content=\"É o e-mail que irá compor o cabeçalho da mensagem como responsável pelo envio. O e-mail válido pode ser o mesmo que o do login.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button> <input name=ema_email type=text class=form-control ng-model=configuracao.usuarioEmail.form.email.ema_email ng-change=configuracao.usuarioEmail.changeEmailValido() required></div><div class=form-group ng-hide=true><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">EVK <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=ema_evk type=text class=form-control ng-model=configuracao.usuarioEmail.form.email.ema_evk required disabled></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Tipo de Autenticação<small> <i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button tabindex=-1 class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=\"Tipo de Autenticação\" data-content=\"O Tipo de Autenticação é o serviço de correio eletrônico utilizado pelo E-mail Válido.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button><ui-select ng-model=configuracao.usuarioEmail.form.email.ema_smtp_type on-select=\"configuracao.usuarioEmail.changeTypeAuth($item, $model)\"><ui-select-match placeholder=\"Smtp Type\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"smtpType.value as smtpType in configuracao.usuarioEmail.selectSmtpTypes | filter:$select.search\"><div ng-bind-html=\"smtpType.name | highlight: $select.search\"></div></ui-select-choices></ui-select><!-- <select selector model=\"configuracao.usuarioEmail.form.email.ema_smtp_type\" options=\"configuracao.usuarioEmail.form.email.smtpTypes\" value-attr=\"value\" change=\"configuracao.usuarioEmail.changeTypeAuth(newValue, oldValue)\" label-attr=\"name\"></select> --></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Host <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button tabindex=-1 class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=Host data-content=\"SMTP do serviço de e-mail utilizado. Para maiores informações, acesse o nosso Help.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button> <input name=ema_smtp_host type=text class=form-control ng-model=configuracao.usuarioEmail.form.email.ema_smtp_host required></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Porta <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button tabindex=-1 class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=Porta data-content=\"Porta de conexão para transferência de Dados. Para maiores informações, acesse o nosso Help.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button><ui-select ng-model=configuracao.usuarioEmail.form.email.ema_smtp_port><ui-select-match placeholder=Portal>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"smtpPort.value as smtpPort in configuracao.usuarioEmail.selectSmtpPorts | filter:$select.search\"><div ng-bind-html=\"smtpPort.name | highlight: $select.search\"></div></ui-select-choices></ui-select><!-- <select selector model=\"configuracao.usuarioEmail.form.email.ema_smtp_port\" options=\"configuracao.usuarioEmail.form.email.smtpPorts\" value-attr=\"value\" label-attr=\"name\"></select> --></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Tipo de Autenticação <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button tabindex=-1 class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=\"Tipo de Autenticação\" data-content=\"Autenticação para transmissão de dados. Para maiores informações, acesse o nosso Help.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button><ui-select ng-model=configuracao.usuarioEmail.form.email.ema_smtp_type_auth><ui-select-match placeholder=Portal>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"smtpTypeAuth.value as smtpTypeAuth in configuracao.usuarioEmail.selectSmtpTypeAuthentications | filter:$select.search\"><div ng-bind-html=\"smtpTypeAuth.name | highlight: $select.search\"></div></ui-select-choices></ui-select><!-- <select selector model=\"configuracao.usuarioEmail.form.email.ema_smtp_type_auth\" options=\"configuracao.usuarioEmail.form.email.smtpTypeAuthentications\" value-attr=\"value\" label-attr=\"name\"></select> --></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Usuário <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=ema_smtp_auth_user type=text class=form-control ng-model=configuracao.usuarioEmail.form.email.ema_smtp_auth_user required></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Senha <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button tabindex=-1 class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=Senha data-content=\"A senha usada no e-mail que foi preenchido no campo E-mail Válido. Essa informação é criptografada.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button> <input name=ema_smtp_auth_password type=password class=form-control ng-model=configuracao.usuarioEmail.form.email.ema_smtp_auth_password required></div><div class=form-group><button type=submit class=\"btn btn-primary btn-lg pull-right\">Salvar</button><div class=clearfix></div></div></form></div></div><!-- Configuração de Email --></div>");
$templateCache.put("app/empresa/empresa-modal.html","<div class=modal-header><button type=button class=close ng-click=\"$dismiss(\'cancel\');\" aria-label=Close><span aria-hidden=true><i class=\"fa fa-times\"></i></span></button><h3 class=\"modal-title text-primary\">{{empresaModal.title}} <button class=\"popover-help text-muted btn-link\" data-toggle=popover title=\"Novo Usuário\" data-content=\"Preencha corretamente os campos solicitados para a criação de um novo usuário no sistema. O novo usuário receberá um e-mail com todas as informações necessária para acessar o sistema.\" data-placement=bottom><i class=\"fa fa-question-circle\"></i></button></h3></div><form name=empresaForm ng-submit=empresaModal.saveEmpresa() method=post><div class=modal-body><div class=row><div class=col-xs-12><div class=page-header><h3 class=text-muted>Informações Cadastrais</h3></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Razão Social <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=emp_codigo type=text class=form-control ng-model=empresaModal.formEmpresa.emp_razao_social required></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">CNPJ <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_cnpj ui-br-cnpj-mask required></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nome Fantasia <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_nome_fantasia required></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Inscrição Estadual</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_inscricao_estadual></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Inscrição Municipal</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_inscricao_municipal></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Telefone</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_telefone ui-br-phone-number></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Telefone 2</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_telefone2 ui-br-phone-number></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Celular</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_celular ui-br-phone-number></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">CEP</label><input name=emp_nome type=text class=form-control ng-blur=empresaModal.pequisaCep() ng-model=empresaModal.formEmpresa.emp_cep ui-br-cep-mask></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Endereço</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_endereco></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Complemento</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_complemento></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Bairro</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_bairro></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Cidade</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_cidade></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">UF</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_uf></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">País</label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.emp_pais></div></div><div class=col-xs-12><div class=page-header><h3 class=text-muted>Responsável</h3></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nome Completo <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.responsavel.emp_res_nome></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">E-mail <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=emp_nome type=text class=form-control ng-model=empresaModal.formEmpresa.responsavel.emp_res_email></div></div></div></div><div class=modal-footer><div class=\"btn-group btn-group-justified\" role=group aria-label=\"Botões de Ação\"><div class=btn-group role=group><button class=\"btn btn-warning\" type=button ng-click=empresaModal.cleanForm()>Limpar</button></div><div class=btn-group role=group><button class=\"btn btn-danger\" type=button ng-click=\"$dismiss(\'cancel\');\">Fechar</button></div><div class=btn-group role=group><button class=\"btn btn-primary\" type=submit ng-disabled=empresaForm.$invalid>Salvar</button></div></div></div></form><script>$(\'[data-toggle=\"popover\"]\').popover();</script>");
$templateCache.put("app/empresa/empresa.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid animated fadeIn\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=# class=\"btn btn-default\"><span class=text-muted>Cadastros</span> </a><a href=# class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Empresas</span></a></div><div class=page-header><h2>Cadastro de Empresas <button class=\"pull-right popover-help text-muted btn-link\" data-toggle=popover title=\"Cadastro de Empresas\" data-content=\"Lista de Empresas cadastradas no sistema. Para adição de nova empresa utilize a opção Nova Empresa no canto superior direito.\" data-placement=left data-container=body data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><div class=\"panel panel-default\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">{{empresa.tituloView}}</h3><button ng-if=\"empresa.usu_nivel == 3\" type=button class=\"btn btn-xs btn-primary pull-right\" ng-click=empresa.openModal(true)><i class=\"fa fa-plus\"></i> Nova Empresa</button> <button ng-click=empresa.reloadData() type=button class=\"btn btn-xs btn-primary pull-right\"><i class=\"fa fa-refresh\"></i> Atualizar</button><div class=clearfix></div></div></div><div class=table-resposive><table datatable=\"\" dt-instance=empresa.dtInstance dt-options=empresa.dtOptions dt-columns=empresa.dtColumns class=\"table table-striped table-hover table-bordered\"></table></div></div></div></div>");
$templateCache.put("app/entidades/entidade-modal.html","<div class=modal-header><button type=button class=close ng-click=\"$dismiss(\'cancel\');\" aria-label=Close><span aria-hidden=true><i class=\"fa fa-times\"></i></span></button><h3 class=\"modal-title text-primary\">Cadastro de Entidades</h3></div><form name=entidadeForm ng-submit=entidadeModal.saveEntidade() method=post><div class=modal-body><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Razão Social <span class=text-danger>*</span></label><input name=\"\" type=text class=form-control ng-model=entidadeModal.formEntidade.ent_razao_social required></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>CNPJ <span class=text-danger>*</span></label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_cnpj ui-br-cnpj-mask required></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Nome Fantasia <span class=text-danger>*</span></label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_nome_fantasia required></div></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"entidadeModal.userNivel == 3?true:false\"><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Tooltip on right\">Empresa <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><ui-select ng-model=entidadeModal.formEntidade.cod_ger_empresa><ui-select-match placeholder=Empresa>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"smtpType.value as smtpType in entidadeModal.selectEmpresas | filter:$select.search\"><div ng-bind-html=\"smtpType.name | highlight: $select.search\"></div></ui-select-choices></ui-select><!-- <select selector model=\"entidadeModal.formEntidade.cod_ger_empresa\" options=\"entidadeModal.empresas\" value-attr=\"value\" label-attr=\"name\"></select> --></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Inscrição Estadual</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_inscricao_estadual></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Inscrição Municipal</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_inscricao_municipal></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Telefone</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_telefone ui-br-phone-number></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Telefone 2</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_telefone2 ui-br-phone-number></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Celular</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_celular ui-br-phone-number></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>CEP</label><input name=ent_nome type=text class=form-control ng-blur=entidadeModal.pequisaCep() ng-model=entidadeModal.formEntidade.ent_cep ui-br-cep-mask></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Endereço</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_endereco></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Complemento</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_complemento></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Bairro</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_bairro></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>Cidade</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_cidade></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>UF</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_uf></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=label-control>País</label><input name=ent_nome type=text class=form-control ng-model=entidadeModal.formEntidade.ent_pais></div></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=entidadeModal.cleanForm()>Limpar</button> <button class=\"btn btn-default\" type=button ng-click=\"$dismiss(\'cancel\');\">Fechar</button> <button class=\"btn btn-primary\" type=submit ng-disabled=entidadeForm.$invalid>Salvar</button></div></form>");
$templateCache.put("app/entidades/entidade.html","<div><acme-navbar></acme-navbar></div><div class=\"container-fluid container-semi-fluid animated fadeIn\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=# class=\"btn btn-default\"><span class=text-muted>Cadastros</span> </a><a href=# class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Entidades</span></a></div><div class=page-header><h2>Entidades <button class=\"pull-right popover-help text-muted btn-link animated pulse infinete\" data-toggle=popover title=Entidades data-content=\"Lista de Entidades cadastradas no sistema. Para adição de nova entidade utilize a opção Nova Entidade no canto superior direito.\" data-placement=left data-trigger=hover data-container=body><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><div class=\"panel panel-default\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">{{entidade.tituloView}}</h3><button ng-if=\"entidade.usu_nivel >= 2\" type=button class=\"btn btn-xs btn-primary pull-right\" ng-click=entidade.openModal(true)><i class=\"fa fa-plus\"></i> Nova Entidade</button> <button ng-click=entidade.reloadData() type=button class=\"btn btn-xs btn-primary pull-right\"><i class=\"fa fa-refresh\"></i> Atualizar</button><div class=clearfix></div></div></div><div class=table-responsive><table datatable=\"\" dt-instance=entidade.dtInstance dt-options=entidade.dtOptions dt-columns=entidade.dtColumns class=\"table table-striped table-hover table-bordered\"></table></div></div></div></div>");
$templateCache.put("app/etiquetas/etiquetas-modal.view.html","<div class=modal-header><button type=button class=close ng-click=\"$dismiss(\'cancel\');\" aria-label=Close><span aria-hidden=true><i class=\"fa fa-times\"></i></span></button><h2 class=\"modal-title text-primary\"><span ng-if=!etiquetasModalCtrl.isAdding>Editar Etiqueta</span> <span ng-if=etiquetasModalCtrl.isAdding>Nova Etiqueta</span> <button class=\"popover-help text-muted btn-link\" data-toggle=popover title=\"Nova Etiqueta\" data-content=\"Preencha corretamente os campos solicitados para a criação de uma nova etiqueta. As etiquetas podem ser usadas nos e-mails para melhor identificação.\" data-placement=bottom data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><form name=formEtiqueta ng-submit=etiquetasModalCtrl.saveEtiqueta() method=post><div class=modal-body><div class=form-group ng-if=!etiquetasModalCtrl.isAdding><label class=label-control>Código da Etiqueta</label><input disabled name=eti_codigo type=text class=form-control ng-model=etiquetasModalCtrl.formEtiqueta.eti_codigo required></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nome da Etiqueta <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=eti_nome type=text class=form-control ng-model=etiquetasModalCtrl.formEtiqueta.eti_nome required></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Cor <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><color-picker ng-model=etiquetasModalCtrl.formEtiqueta.eti_cor options=etiquetasModalCtrl.optionsColorPicker></color-picker></div></div><div class=modal-footer><div class=\"btn-group btn-group-justified\" role=group aria-label=\"Botões de Ação\"><div class=btn-group role=group><button class=\"btn btn-warning\" type=button ng-click=etiquetasModalCtrl.cleanForm()><i class=\"fa fa-eraser\"></i> Limpar</button></div><div class=btn-group role=group><button class=\"btn btn-danger\" type=button ng-click=\"$dismiss(\'cancel\');\"><i class=\"fa fa-times\"></i> Fechar</button></div><div class=btn-group role=group><button class=\"btn btn-primary\" type=submit ng-disabled=formEtiqueta.$invalid><i class=\"fa fa-save\"></i> Salvar</button></div></div></div></form><script>$(\'[data-toggle=\"popover\"]\').popover();\n    $(\'[data-toggle=\"tooltip\"]\').tooltip();</script>");
$templateCache.put("app/etiquetas/etiquetas.view.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=# class=\"btn btn-default\"><span class=text-muted>Cadastros</span> </a><a href=# class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Etiquetas</span></a></div><div class=page-header><h2>Cadastro de Etiquetas <button class=\"pull-right popover-help text-muted btn-link btn-link animated pulse infinete\" data-toggle=popover title=\"Cadastro de Etiquetas\" data-content=\"Lista de etiquetas cadastradas no sistema. Para adição de uma nova etiqueta utiliza o botão Nova Etiqueta no canto superior direito.\" data-placement=left data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><div class=\"panel panel-default h-no-margin\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">Tabela de Etiquetas</h3><button type=button class=\"btn btn-xs btn-primary pull-right\" ng-click=etiquetasCtrl.openModal(true)><i class=\"fa fa-plus hidden-sm hidden-md hidden-lg\"></i> <span class=hidden-xs>Nova Etiqueta</span></button><div class=clearfix></div></div></div><div><table datatable=\"\" dt-instance=etiquetasCtrl.dtInstance dt-options=etiquetasCtrl.dtOptions dt-columns=etiquetasCtrl.dtColumns class=\"table table-striped table-hover table-bordered\"></table></div></div></div></div>");
$templateCache.put("app/leads/leads-modal.view.html","<div class=modal-header><button type=button class=close ng-click=\"$dismiss(\'cancel\');\" aria-label=Close><span aria-hidden=true><i class=\"fa fa-times\"></i></span></button><h2 class=\"modal-title text-primary\"><span ng-if=!leadsModalCtrl.isAdding>Editar Lead/Contato</span> <span ng-if=leadsModalCtrl.isAdding>Novo Lead/Contato</span> <button class=\"popover-help text-muted btn-link\" data-toggle=popover title=\"Novo Lead/Contato\" data-content=\"Preencha corretamente os campos solicitados para a criação de um novo lead/contato. O novo lead/contato poderá ser utilizado para envio de e-mails.\" data-placement=bottom data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><form name=formLead ng-submit=leadsModalCtrl.saveLead() method=post><div class=modal-body><div class=form-group ng-if=!leadsModalCtrl.isAdding><label class=label-control>Código do Lead/Contato</label><input disabled name=lea_codigo type=text class=form-control ng-model=leadsModalCtrl.formLead.lea_codigo required></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nome do Lead/Contato <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=lea_nome type=text class=form-control ng-model=leadsModalCtrl.formLead.lea_nome required></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Email <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input name=lea_email type=email class=form-control ng-model=leadsModalCtrl.formLead.lea_email required></div></div><div class=modal-footer><div class=\"btn-group btn-group-justified\" role=group aria-label=\"Botões de Ação\"><div class=btn-group role=group><button class=\"btn btn-warning\" type=button ng-click=leadsModalCtrl.cleanForm()><i class=\"fa fa-eraser\"></i> Limpar</button></div><div class=btn-group role=group><button class=\"btn btn-danger\" type=button ng-click=\"$dismiss(\'cancel\');\"><i class=\"fa fa-times\"></i> Fechar</button></div><div class=btn-group role=group><button class=\"btn btn-primary\" type=submit ng-disabled=formLead.$invalid><i class=\"fa fa-save\"></i> Salvar</button></div></div></div></form><script>$(\'[data-toggle=\"popover\"]\').popover();\n    $(\'[data-toggle=\"tooltip\"]\').tooltip();</script>");
$templateCache.put("app/leads/leads.view.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=# class=\"btn btn-default\"><span class=text-muted>Cadastros</span> </a><a href=# class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Leads/Contatos</span></a></div><div class=page-header><h2>Cadastro de Leads/Contatos <button class=\"pull-right popover-help text-muted btn-link btn-link animated pulse infinete\" data-toggle=popover title=\"Cadastro de Lead\" data-content=\"Lista de Leads cadastrados no sistema. Para adição de novo usuário utilize a opção Novo Lead no canto superior direito\" data-placement=left data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><div class=\"panel panel-default h-no-margin\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">Tabela de Leads/Contatos</h3><button type=button class=\"btn btn-xs btn-primary pull-right\" ng-click=leadsCtrl.openModal(true)><i class=\"fa fa-plus hidden-sm hidden-md hidden-lg\"></i> <span class=hidden-xs>Novo Lead/Contato</span></button><div class=clearfix></div></div></div><div><table datatable=\"\" dt-instance=leadsCtrl.dtInstance dt-options=leadsCtrl.dtOptions dt-columns=leadsCtrl.dtColumns class=\"table table-striped table-hover table-bordered\"></table></div></div></div></div>");
$templateCache.put("app/lista/criar-lista.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid animated fadeIn\"><div class=\"btn-group btn-group-xs btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i></a> <a href=# class=\"btn btn-default\"><span class=text-muted>Campanhas</span></a> <a href=/campanhas/lista class=\"btn btn-default\"><span class=text-muted>Lista de E-mail</span></a> <a href=/campanhas/criar-lista class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Criar Lista</span></a></div><div class=page-header><h2>Criar Lista <button class=\"pull-right popover-help text-muted btn-link animated pulse infinete\" data-toggle=popover title=\"Criar Lista\" data-content=\"Para a criação de uma nova lista de e-mails, adicione o Nome da Lista e realize o upload de Arquivo no formato .CSV. Para criação de arquivo .CSV dentro dos padrões, faça download do nosso modelo.\" data-placement=left data-trigger=hover data-container=body><i class=\"fa fa-question-circle-o\"></i></button></h2></div><form><div class=row><div class=col-xs-12><div class=row><div class=col-xs-12><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nome <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input type=text class=form-control required></div></div></div><div class=row><div class=\"col-xs-12 col-sm-4 col-sm-offset-2 col-md-3 col-md-offset-3\"></div></div><div class=\"well text-center\"><h1 class=text-muted><i class=\"fa fa-upload fa-2x\"></i></h1><h3 class=text-muted>Importe uma lista CSV em UTF-8</h3><h3 class=text-muted>Ela deve conter as informações divididas em colunas no modelo CSV</h3><button type=button class=\"btn btn-link btn-lg\">Baixar Modelo CSV</button><ng-csv-import class=import content=lista.csv.content header=lista.csv.header separator=lista.csv.separator result=lista.csv.result encoding=lista.csv.encoding callback=lista.processCsv></ng-csv-import></div><div class=content>Leitura do arquivo<pre>\n						{{lista.csv.result}}\n					</pre></div>Ng-repeat {{lista.collumnsCsv}} Inputs {{lista.resultadoInputs}}<div ng-repeat=\"collumn in lista.collumnsCsv\"><div class=input-group><div><input class=form-control type=text value={{collumn}} disabled></div><input class=form-control type=text ng-model=lista.resultadoInputs[collumn]></div></div><div><button type=button class=\"btn btn-link btn-lg\" ng-click=lista.getColl()>SALVAR</button></div></div></div></form></div>");
$templateCache.put("app/lista/lista.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid animated fadeIn\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i></a> <a href=# class=\"btn btn-default\"><span class=text-muted>Campanhas</span></a> <a href=/campanhas/lista class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Lista de E-mail</span></a></div><div class=page-header><h2>Lista de E-mail <button class=\"pull-right popover-help text-muted btn-link btn-link animated pulse infinete\" data-toggle=popover title=\"Lista de E-mail\" data-content=\"Listas de e-mails cadastrados. Para adição de nova Lista, utilize o botão Criar Nova Lista, para edição de uma lista clique no título da mesma ou utilize a opção Editar no menu da grade.\" data-placement=left data-container=body data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><div class=\"panel panel-default\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">{{lista.tituloView}}</h3><a href=/campanhas/criar-lista class=\"btn btn-xs btn-primary pull-right\"><i class=\"fa fa-plus\"></i> Nova Lista</a><div class=clearfix></div></div></div><div class=table-resposive><table datatable=\"\" dt-options=lista.dtOptions dt-column-defs=lista.dtColumnDefs class=\"table table-striped table-hover table-bordered\"><thead><tr><th class=text-primary>ID</th><th class=text-primary>Nome</th><th class=\"text-center text-primary\">Criado</th><th class=\"text-center text-primary\">Gerenciar</th></tr></thead><tbody><tr><td>1</td><td>Welinton</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open) dropdown-append-to-body><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr><tr><td>2</td><td>Rafael</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr><tr><td>3</td><td>Roberto</td><td class=text-center>22/01/1985</td><td class=text-center><span uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle><i class=\"fa fa-cog fa-lg fa-fw\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=\"\"><li><a href=\"\"><i class=\"fa fa-pencil\"></i> Editar</a></li><li><a href><i class=\"fa fa-copy\"></i> Duplicar</a></li><li><a href><i class=\"fa fa-trash\"></i> Remover</a></li></ul></span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/lista/novo-campo-modal.html","<div class=modal-header><button type=button class=close ng-click=\"$dismiss(\'cancel\');\" aria-label=Close><span aria-hidden=true><i class=\"fa fa-times\"></i></span></button><h3 class=modal-title>Novo Campo <button class=\"popover-help text-muted btn-link\" data-toggle=popover title=\"Novo Usuário\" data-content=\"Preencha corretamente os campos solicitados para a criação de um novo usuário no sistema. O novo usuário receberá um e-mail com todas as informações necessária para acessar o sistema.\" data-placement=bottom><i class=\"fa fa-question-circle-o\"></i></button></h3></div><form name=listaForm ng-submit=novoCampoModal method=post><div class=modal-body><div class=form-group><label class=label-control>Nome do Campo <span class=text-danger>*</span></label><input name=ent_codigo type=text class=form-control ng-model=novoCampoModal.listaForm.teste required></div><div class=form-group><label class=label-control>Nome da Variável <span class=text-danger>*</span></label><input name=ent_nome type=text class=form-control ng-model=novoCampoModal.listaForm.teste2 required></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=novoCampoModal.cleanForm()>Limpar</button> <button class=\"btn btn-default\" type=button ng-click=\"$dismiss(\'cancel\');\">Fechar</button> <button class=\"btn btn-primary\" type=submit ng-disabled=listaForm.$invalid>Salvar</button></div></form><script>$(\'[data-toggle=\"popover\"]\').popover();</script>");
$templateCache.put("app/login/login-old.html","<div class=\"container-fluid container-semi-fluid\" style=z-index:99999999999999999999999999999><style>body{ \n		height:100vh;\n		background-color: #fcca15;\n		background: #fcca15;\n		background: -moz-linear-gradient(top,  #fcca15 0%, #f4d873 14%);\n		background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#fcca15), color-stop(14%,#f4d873));\n		background: -webkit-linear-gradient(top,  #fcca15 0%,#f4d873 14%);\n		background: -o-linear-gradient(top,  #fcca15 0%,#f4d873 14%);\n		background: -ms-linear-gradient(top,  #fcca15 0%,#f4d873 14%);\n		background: linear-gradient(to bottom,  #fcca15 0%,#f4d873 14%);\n		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#fcca15\', endColorstr=\'#f4d873\',GradientType=0 );\n	}\n	.navbar-fixed-top{animation: zoomOutUp 1s ease-in-out;}</style><div style=padding-top:5vh class=\"row hidden-sm hidden-md hidden-lg\"></div><div style=padding-top:15vh class=\"row hidden-xs\"></div><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 text-center\"><img src=/assets/images/main-logo-black.svg class=\"img-responsive center-block\" alt=\"Logo AirMail\" style=\"max-width:50%; margin-bottom:25px\"></div><div class=\"col-xs-12 col-sm-5 col-md-4\"><div class=\"panel panel-primary\"><div class=panel-heading><h3 class=\"panel-title text-center\">Login</h3></div><div class=panel-body><form accept-charset=UTF-8 role=form ng-submit=login.login()><fieldset><div class=form-group><div class=\"input-group input-group-lg\"><span class=\"input-group-addon bg-warning\" id=basic-addon1><i class=\"fa fa-envelope fa-fw\"></i> </span><input class=form-control placeholder=E-mail name=username ng-model=login.username type=text></div></div><div class=form-group><div class=\"input-group input-group-lg\"><span class=input-group-addon id=basic-addon2><i class=\"fa fa-key fa-fw\"></i> </span><input class=form-control placeholder=Senha name=password ng-model=login.password type=password></div></div><div class=form-group><div class=\"checkbox cr-fix\"><label style=\"font-size: 1.1em;padding-left: 0\"><input name=remember type=checkbox value=\"Remember Me\"> <span class=cr><i class=\"cr-icon fa fa fa-check text-primary\"></i> </span>Manter Logado</label></div></div><button class=\"btn btn-lg btn-primary btn-block\" type=submit>Login</button> <button class=\"btn-link btn-block\" data-toggle=collapse data-target=#recuperar type=button>Esqueci Minha Senha</button></fieldset></form><div class=collapse id=recuperar><hr><h5>Recuperar</h5><form><div class=form-group><input type=email class=form-control placeholder=\"Seu E-mail Cadastrado\"></div><button class=\"btn btn-xs btn-danger btn-block\" type=submit>Enviar</button></form></div></div></div></div></div></div>");
$templateCache.put("app/login/login.html","<div class=\"container-fluid container-fluid\" style=\"z-index:99999999999999999999999999999; position: relative\"><style>body{\n		height:100vh;\n	}\n	.navbar-fixed-top{animation: zoomOutUp 1s ease-in-out;}\n	.footer{\n		background-color:#0a437c;\n		position: fixed;\n		bottom: 0;\n		left: 0;\n		width: 100%;\n		height: 40px;\n	}\n	.scroll-top-wrapper.show {\n		display: none !important;\n	}</style><div class=row><nav class=\"navbar navbar-default\"><div class=container><!-- Brand and toggle get grouped for better mobile display --><div class=navbar-header><button style=\"color: #9D9D9D;padding: 7px 10px 6px\" type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse-login aria-expanded=false><i class=\"fa fa-bars fa-2x\"></i></button> <a class=navbar-brand href=#><img alt=\"Ar Mail Logo\" style=\"max-width: 100px; height:45.5px\" src=/assets/images/main-logo-horizontal.svg></a></div><div class=\"collapse navbar-collapse\" id=navbar-collapse-login><ul class=\"nav navbar-nav navbar-right\"><li><a href=http://www.ar-email.com.br><i class=\"fa fa-chevron-left\" aria-hidden=true></i> Voltar</a></li><li class=\"dropdown hidden\"><a href=# class=dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false>Dropdown <span class=caret></span></a><ul class=dropdown-menu><li><a href=#>Action</a></li><li><a href=#>Another action</a></li><li><a href=#>Something else here</a></li><li role=separator class=divider></li><li><a href=#>Separated link</a></li></ul></li></ul></div></div></nav></div><div style=padding-top:15vh class=\"row hidden-xs\"></div><div class=row style=\"padding-bottom: 80px\"><div class=\"col-xs-12 col-sm-6 col-md-5 col-md-offset-1 text-center hidden-xs\"><img src=/assets/images/selo.svg class=\"animated zoomIn\" alt=\"Logo AirMail\" style=\"max-width:15%; margin-bottom:10px\"><h1 class=\"text-primary hidden-sm\">Notificações Eletrônicas</h1><h3 class=\"text-primary visible-sm-block\">Notificações Eletrônicas</h3><h2 class=\"text-warning hidden-sm\">E-mail com validade jurídica e Aviso de Recebimento</h2><h4 class=\"text-warning visible-sm-block\">E-mail com validade jurídica e Aviso de Recebimento</h4><div style=\"margin-bottom: 25px\"></div></div><div class=\"col-xs-12 col-sm-5 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading><h3 class=\"panel-title text-center\"><img src=/assets/images/main-logo-horizontal.svg class=\"img-responsive center-block animated zoomIn\" alt=\"Logo AirMail\" style=max-width:50%></h3></div><div class=panel-body><form accept-charset=UTF-8 role=form ng-submit=login.login()><fieldset><div class=form-group><div class=\"input-group input-group-lg\"><span class=\"input-group-addon bg-warning\" id=basic-addon1><i class=\"fa fa-envelope fa-fw\"></i> </span><input class=form-control placeholder=E-mail name=username ng-model=login.username required type=text></div></div><div class=form-group><div class=\"input-group input-group-lg\"><span class=input-group-addon id=basic-addon2><i class=\"fa fa-key fa-fw\"></i> </span><input class=form-control placeholder=Senha name=password ng-model=login.password required type=password></div></div><!-- <div class=\"form-group\">\n								<div class=\"checkbox cr-fix\">\n									<label style=\"font-size: 1.1em;padding-left: 0;\">\n										<input name=\"remember\" type=\"checkbox\" value=\"Remember Me\">\n										<span class=\"cr\"> <i class=\"cr-icon fa fa fa-check text-primary\"></i> </span> Manter Logado </label>\n								</div>\n							</div> --> <button class=\"btn btn-lg btn-primary btn-block\" id=loginBtn data-loading-text=Entrando... type=submit>Login</button> <button class=\"btn-link btn-block\" data-toggle=collapse data-target=#recuperar type=button>Esqueci Minha Senha</button></fieldset></form><div class=collapse id=recuperar><hr><h5>Recuperar</h5><form class=\"ng-pristine ng-valid\" name=formUsersRecoveryPassword ng-submit=login.recoveryPassword()><div class=form-group><input type=email class=form-control placeholder=\"Seu E-mail Cadastrado\" required ng-model=login.formUsersRecoveryPassword.emailUserRecovery></div><button class=\"btn btn-xs btn-danger btn-block\" type=submit ng-disabled=formUsersRecoveryPassword.$invalid>Enviar</button></form></div></div></div></div></div><div class=footer><p class=text-center style=\"margin-top: 10px;color: #fff\">Termos de Uso - Política de Privacidade</p></div></div>");
$templateCache.put("app/mail-unico/info-mail-unico.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid animated fadeIn\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=/mail-unico/mail-unico class=\"btn btn-default\"><span class=text-muted>E-Mail Único </span></a><a href=# class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Visualizar E-Mail</span></a></div><div class=page-header><h2>Visualizar E-Mail <button class=\"pull-right popover-help text-muted btn-link animated pulse infinete\" data-toggle=popover title=\"Visualizar E-Mail\" data-content=\"E-mail já enviado. A visualização mostra todas as informações referente ao e-mail, caso queira enviá-lo novamente, será preciso criar uma cópia do mesmo com a opção duplicar.\" data-placement=left data-container=body data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=\"panel panel-default\" ng-if=false><div class=panel-heading><!-- <a class=\"btn btn-primary btn-xs pull-right\" href=\"/mail-unico/novo-mail-unico\"> --> <a class=\"btn btn-primary btn-xs pull-right\" ui-sref=\"novo-mail-unico({duplicate: mailUnico.emailInfo})\">Duplicar</a><div class=clearfix></div></div></div><!--apenas no Visualizar E-Mail --><!-- <button type=\"button\" class=\"btn btn-primary pull-right btn-lg\" ng-click=\"active = 1\">Abrir</button> --><div class=row><div class=col-xs-12><div class=row><div class=col-xs-12><div class=\"panel panel-default\"><!-- Default panel contents --><div class=panel-heading><h3 class=\"panel-title text-primary\">Status</h3></div><ul class=list-group><li class=\"list-group-item animated fadeIn\" ng-if=\"mailUnico.lastStatus === \'processado\'\">Processado</li><li class=\"list-group-item animated fadeIn\" ng-if=mailUnico.status.erro>Ocorreu um Erro</li><li class=\"list-group-item animated fadeIn\" ng-if=\"mailUnico.status.dataEnviado && !mailUnico.status.erro\">Enviado em: <span class=pull-right><i class=\"fa fa-calendar\"></i> {{mailUnico.status.dataEnviado}}</span><div class=clearfix></div></li><li class=\"list-group-item animated fadeIn\" ng-if=\"mailUnico.status.dataEntregue  && !mailUnico.status.erro\">Entregue em: <span class=pull-right><i class=\"fa fa-calendar\"></i> {{mailUnico.status.dataEntregue}}</span><div class=clearfix></div></li><li class=\"list-group-item animated fadeIn\" ng-if=\"mailUnico.status.lidoData1Leitura  && !mailUnico.status.erro\">Lido em: <span class=pull-right><i class=\"fa fa-calendar\"></i> {{mailUnico.status.lidoData1Leitura}}</span><div class=clearfix></div></li></ul></div></div><div class=\"col-xs-12 col-sm-8\"><div class=form-group><label class=label-control>Código Email</label><input type=text class=form-control ng-model=mailUnico.emailInfo.codEmailUnico readonly></div><div class=form-group><label class=label-control>Modelo</label><input type=text class=form-control ng-model=mailUnico.emailInfo.modelo readonly></div><div></div><div class=form-group><label class=label-control>Para</label><input type=text class=form-control ng-model=mailUnico.emailInfo.to readonly></div><div class=form-group><label class=label-control>Assunto</label><input type=text class=form-control ng-model=mailUnico.emailInfo.subject readonly></div></div><div class=\"col-xs-12 col-sm-4\" ng-if=mailUnico.emailInfo.attachments><div class=\"panel panel-default\"><!-- Default panel contents --><div class=panel-heading><h3 class=\"panel-title text-primary\">Anexos</h3></div><ul class=list-group><li class=list-group-item ng-repeat=\"attachment in mailUnico.emailInfo.attachments track by $index\"><a href=\"\" ng-click=\"mailUnico.downloadAttachment(mailUnico.emailInfo.codEmailUnico, attachment)\">{{attachment.originalFilename}}</a></li></ul></div></div></div><uib-tabset active=active justified=false><uib-tab index=1 heading=Mensagem><div class=\"panel panel-default h-no-margin\" style=\"border-radius: 0px 0px 4px 4px\"><div class=panel-heading ng-bind-html=mailUnico.emailInfo.content></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/mail-unico/mail-unico.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=# class=\"btn btn-default\"><span class=text-muted>E-Mails</span> </a><a href=/mail-unico/mail-unico class=\"btn btn-default animated fadeInRight\"><span class=text-muted>E-Mail Enviados</span></a></div><div class=page-header><h2>E-Mail Enviados <button class=\"pull-right popover-help text-muted btn-link animated pulse infinete\" data-toggle=popover title=\"E-Mail Único\" data-content=\"Envio de E-mail para um único destinatário. Para envio de novo e-mail, utilize o botão Novo E-mail, para criar uma cópia de um e-mail já enviado, utilize a opção Duplicar no menu da grade.\" data-placement=left data-container=body data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><div class=\"panel panel-default h-no-margin\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">{{mailUnico.tituloView}}</h3><a class=\"btn btn-primary btn-xs pull-right\" ui-sref=novo-mail-unico><i class=\"fa fa-plus hidden-sm hidden-md hidden-lg\"></i> <span class=hidden-xs>Novo E-mail</span></a> <a class=\"btn btn-primary btn-xs pull-right\" ng-click=mailUnico.reloadData() style=margin-right:5px><i class=\"fa fa-refresh hidden-sm hidden-md hidden-lg\"></i> <span class=hidden-xs>Atualizar</span></a><div class=clearfix></div><br><div class=input-group><ui-select ng-model=mailUnico.cod_ger_etiqueta><ui-select-match placeholder=\"Filtrar Etiquetas\" ng-style=\"{\'color\': $select.selected.eti_cor}\"><i class=\"fa fa-square\" aria-hidden=true ng-style=\"{\'color\': $select.selected.eti_cor}\"></i> {{$select.selected.eti_nome}}</ui-select-match><ui-select-choices repeat=\"etiqueta.eti_codigo as etiqueta in mailUnico.etiquetas | filter:$select.search\"><i class=\"fa fa-square\" aria-hidden=true ng-style=\"{\'color\': etiqueta.eti_cor}\"></i> <span ng-bind-html=\"etiqueta.eti_nome | highlight: $select.search\"></span> <small class=sr-only>Cor: {{etiqueta.eti_cor}}</small></ui-select-choices></ui-select><span class=input-group-btn><button class=\"btn btn-warning\" ng-if=mailUnico.cod_ger_etiqueta title=Limpar ng-click=mailUnico.clear()><i class=\"fa fa-eraser fa-fw\" aria-hidden=true></i></button> <button class=\"btn btn-primary\" title=\"Filtrar Etiquetas\" type=button ng-click=mailUnico.filterTable()><i class=\"fa fa-filter fa-fw\" aria-hidden=true></i></button></span></div></div></div><div><table datatable=\"\" dt-instance=mailUnico.dtInstance dt-options=mailUnico.dtOptions dt-columns=mailUnico.dtColumns class=\"table table-striped table-hover table-bordered\" width=100%></table></div></div></div></div>");
$templateCache.put("app/mail-unico/main-unico-attachments-modal.view.html","<div class=modal-header><button type=button class=close ng-click=\"$dismiss(\'cancel\');\" aria-label=Close><span aria-hidden=true><i class=\"fa fa-times\"></i></span></button><h2 class=\"modal-title text-primary\"><span>Visualizar Pdf</span> <button class=\"popover-help text-muted btn-link hidden\" data-toggle=popover title=\"Novo Lead/Contato\" data-content=\"Preencha corretamente os campos solicitados para a criação de um novo lead/contato. O novo lead/contato poderá ser utilizado para envio de e-mails.\" data-placement=bottom data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=modal-body><ng-pdf template-url=assets/partials/viewer.html canvasid=pdf scale=page-fit></ng-pdf></div><div class=modal-footer><div class=\"btn-group btn-group-justified\" role=group aria-label=\"Botões de Ação\"><div class=btn-group role=group><button class=\"btn btn-danger\" type=button ng-click=\"$dismiss(\'cancel\');\"><i class=\"fa fa-times\"></i> Fechar</button></div></div></div><script>$(\'[data-toggle=\"popover\"]\').popover();\n    $(\'[data-toggle=\"tooltip\"]\').tooltip();</script>");
$templateCache.put("app/mail-unico/novo-mail-unico.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=/mail-unico/mail-unico class=\"btn btn-default\"><span class=text-muted>E-Mails</span> </a><a href=/mail-unico/novo-mail-unico class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Enviar E-Mail</span></a></div><div class=page-header><h2>Novo E-Mail <button class=\"pull-right popover-help text-muted btn-link animated pulse infinete\" data-toggle=popover title=\"Novo E-Mail\" data-content=\"O usuário poderá realizar disparos de email para um destinatário.\" data-placement=left data-container=body data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><!--apenas no Visualizar E-Mail --><div class=row><div class=col-xs-12><form name=form method=post ng-submit=mailUnico.saveEmail()><!-- <div class=\"form-group\">\n          <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">Para <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i></small></label>\n          <input type=\"email\" class=\"form-control\" ng-model=\"mailUnico.formEmail.to\" required>\n        </div> --><!-- Email --><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Para (somente um destinatário)<small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><ui-select multiple limit=1 tagging=mailUnico.tagTransformLead on-select=\"mailUnico.validateEmail($item, $model)\" ng-model=mailUnico.formEmail.to ng-required=true><ui-select-match placeholder=\"\">{{$item.name}} &lt;{{$item.email}}&gt;</ui-select-match><ui-select-choices repeat=\"lead as lead in mailUnico.leads | filter:$select.search\"><div ng-bind-html=\"lead.name | highlight: $select.search\"></div><small>E-mail: {{lead.email}}</small></ui-select-choices></ui-select></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Modelo de Email<small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><ui-select ng-model=mailUnico.formEmail.modelo on-select=mailUnico.changeContent($select.selected) ng-enable=false><ui-select-match placeholder=\"\">{{$select.selected.mod_name}}</ui-select-match><ui-select-choices repeat=\"modelo as modelo in mailUnico.formEmail.modelos | filter:$select.search\"><div ng-bind-html=\"modelo.mod_name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><!-- Assunto --><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Assunto <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input type=text class=form-control ng-model=mailUnico.formEmail.subject required></div><!-- Etiquetas --><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right>Etiquetas</label><ui-select multiple ng-model=mailUnico.formEmail.etiquetas><ui-select-match placeholder=\"\"><i class=\"fa fa-square\" aria-hidden=true ng-style=\"{\'color\': $item.eti_cor}\"></i> {{$item.eti_nome}}</ui-select-match><ui-select-choices repeat=\"etiqueta.eti_codigo as etiqueta in mailUnico.etiquetas | filter:$select.search\"><i class=\"fa fa-square\" aria-hidden=true ng-style=\"{\'color\': etiqueta.eti_cor}\"></i> <span ng-bind-html=\"etiqueta.eti_nome | highlight: $select.search\"></span> <small class=sr-only>Cor: {{etiqueta.eti_cor}}</small></ui-select-choices></ui-select></div><!-- Anexos Customizar --> <button ngf-drop=\"\" ngf-select=\"\" ngf-drop-available=dropAvailable ngf-enable-firefox-paste=true class=\"btn btn-default\" type=file ng-model=mailUnico.attachments name=file ngf-pattern=\"\'.gif,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.zip\'\" ngf-max-total-size=5MB ngf-keep=distinct ngf-allow-dir=allowDir ngf-model-invalid=errorFile ngf-multiple=true ngf-capture=capture><i class=\"fa fa-paperclip fa-lg fa-fw\"></i> Anexar</button><p class=help-block>Tamanho máximo permitido: 5MB</p><p class=help-block>Extensões Permitidas: gif, jpg, png, doc, docx, xls, xlsx, pdf, zip</p><p class=\"text-center text-danger animated pulse infinite\" ng-show=form.file.$error.maxTotalSize><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i> Total permitido são 5MB - {{errorFile.size / 1000000|number:1}}MB: max 5Mb<br>Tente Novamente.</p><p class=\"text-center text-danger animated pulse infinite\" ng-show=form.file.$error.pattern><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i> Você só pode enviar os seguintes arquivos: pdf, doc, docx, xls, xlsx, txt, rtf, jpg, jpeg, png, gif<br>Tente Novamente.</p><ul class=list-unstyled style=\"display: flex;flex-wrap: wrap\"><li ng-repeat=\"attachment in mailUnico.attachments track by $index\" class=\"well well-sm attach\" style=margin-right:10px><span class=h4><i class=\"fa fa-paperclip fa-fw text-muted\"></i> <img style=\"max-width: 50px;max-height: 30px\" ngf-src=\"!mailUnico.attachments[$index].$error && mailUnico.attachments[$index]\" alt=\"imagem anexo\"> <span class=text-muted>{{attachment.name}}</span> <small><span class=\"label label-default\">{{attachment.size / 1000000|number:1}} MB</span></small> <button class=\"btn btn-default btn-xs\" type=button ng-click=mailUnico.removeAttachments(attachment) ng-show=mailUnico.attachments><i class=\"fa fa-trash fa-lg\"></i></button></span></li></ul><div class=help-block ng-messages=form.file.$error ng-if=\"form.files.$dirty && form.file.$invalid\"><span ng-message=pattern class=pull-left>You can only upload following files: pdf, doc, docx, xls, xlsx, txt, rtf, jpg, jpeg, png, gif</span> <span ng-message=maxSize class=pull-left>Your file(s) larger than the maximum allowed of 1MB per a file.</span> <span ng-message=maxFiles class=pull-left>You can only select maximum 5 files at a time.</span> <span ng-message=maxTotalSize class=pull-left>The total size of attached files exceeds than 5MB</span></div><br><uib-tabset active=active justified=false><uib-tab index=1 heading=Mensagem><div class=form-group><textarea ui-tinymce=mailUnico.tinymceOptions ng-model=mailUnico.formEmail.content></textarea></div><div class=form-group><button ng-disabled=!form.$valid type=submit class=\"btn btn-primary pull-right btn-lg\">Enviar</button><div class=clearfix></div></div></uib-tab></uib-tabset></form></div></div></div>");
$templateCache.put("app/main/main.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid\"><div class=page-header><h2>Dashboard <button class=\"pull-right popover-help text-muted btn-link animated pulse infinete\" data-toggle=popover title=Dashboard data-content=\"Painel de informações das últimas ações realizadas no Ar-Email. Para acesso à registros mais detalhados, visite as respectivas áreas.\" data-placement=left data-container=body data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><div class=\"panel panel-default\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">Resumo E-Mails Enviados</h3><a href=/campanhas/campanhas class=\"btn btn-xs btn-primary pull-right\"><i class=\"fa fa-link\"></i></a><div class=clearfix></div></div><div class=panel-body style=\"background-color: #f5f5f5\"><div class=\"row little-infos\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"well well-small\"><div class=row><div class=\"col-xs-12 col-sm-4 text-center\"><i class=\"fa fa-cogs fa-4x animated flipInY anime-0-6s\"></i></div><div class=\"col-xs-12 col-sm-8 text-center\"><h4 class=\"text-muted h-no-margin\">Processados</h4><h3 class=h-no-margin-bottom ng-if=main.totalProcessados>{{main.totalProcessados}}</h3><h4 class=h-no-margin-bottom ng-if=!main.totalProcessados>Não informado</h4></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"well well-small\"><div class=row><div class=\"col-xs-12 col-sm-4 text-center\"><i class=\"fa fa-paper-plane fa-4x text-primary animated flipInY anime-0-8s\"></i></div><div class=\"col-xs-12 col-sm-8 text-center\"><h4 class=\"text-muted h-no-margin\">Enviados</h4><h3 class=h-no-margin-bottom ng-if=main.totalEnviados>{{main.totalEnviados}}</h3><h4 class=h-no-margin-bottom ng-if=!main.totalEnviados>Não informado</h4></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"well well-small\"><div class=row><div class=\"col-xs-12 col-sm-4 text-center\"><i class=\"fa fa-check fa-4x text-success animated flipInY anime-1s\"></i></div><div class=\"col-xs-12 col-sm-8 text-center\"><h4 class=\"text-muted h-no-margin\">Entregues</h4><h3 class=h-no-margin-bottom ng-if=main.totalEntregues>{{main.totalEntregues}}</h3><h4 class=h-no-margin-bottom ng-if=!main.totalEntregues>Não informado</h4></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"well well-small\"><div class=row><div class=\"col-xs-12 col-sm-4 text-center\"><i class=\"fa fa-folder-open fa-4x text-warning animated flipInY anime-1-2s\"></i></div><div class=\"col-xs-12 col-sm-8 text-center\"><h4 class=\"text-muted h-no-margin\">Lidos</h4><h3 class=h-no-margin-bottom ng-if=main.totalLidos>{{main.totalLidos}}</h3><h4 class=h-no-margin-bottom ng-if=!main.totalLidos>Não informado</h4></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-sm-push-3 col-md-push-4\"><div class=\"well well-small\"><div class=row><div class=\"col-xs-12 col-sm-4 text-center\"><i class=\"fa fa-exclamation-triangle fa-4x text-danger animated flipInY anime-1-4s\"></i></div><div class=\"col-xs-12 col-sm-8 text-center\"><h4 class=\"text-muted h-no-margin\">Erro na Entrega</h4><h3 class=h-no-margin-bottom ng-if=main.totalErro>{{main.totalErro}}</h3><h4 class=h-no-margin-bottom ng-if=!main.totalErro>Não informado</h4></div></div></div></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-8\"><div class=\"panel panel-default\" ng-if=false><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">* Lista Criada</h3><a href=/campanhas/lista class=\"btn btn-xs btn-primary pull-right\"><i class=\"fa fa-link\"></i></a><div class=clearfix></div></div><div class=table-responsive><table class=\"table table-hover table-striped\"><thead><tr><th class=text-primary>#</th><th class=text-primary>First Name</th><th class=text-primary>Last Name</th></tr></thead><tbody><tr><th scope=row>1</th><td>Mark</td><td>Otto</td></tr><tr><th scope=row>2</th><td>Jacob</td><td>Thornton</td></tr><tr><th scope=row>3</th><td>Larry</td><td>the Bird</td></tr></tbody></table></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">Últimos Modelos Criados</h3><a href=/campanhas/modelos class=\"btn btn-xs btn-primary pull-right\"><i class=\"fa fa-link\"></i></a><div class=clearfix></div></div><div ng-if=main.lastModelos class=\"table-responsive animated fadeIn anime-0-6s\"><table class=\"table table-hover table-striped\"><thead><tr><th class=text-primary>#</th><th class=text-primary>Nome</th><th class=text-primary>Criação</th></tr></thead><tbody ng-if=main.lastModelos><tr ng-repeat=\"modelo in main.lastModelos\"><td scope=row>{{modelo.mod_codigo}}</td><td>{{modelo.mod_name}}</td><td>{{modelo.mod_data_criacao}}</td></tr></tbody><tbody ng-if=!main.lastModelos.length><tr><td colspan=3 class=\"text-center text-muted\" scope=row>Nenhum Registro Encontrado</td></tr></tbody></table></div></div></div><div class=\"col-xs-12 col-sm-4\"><div class=\"panel panel-default\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">Último E-mail Enviado</h3><a ui-sref=\"info-mail-unico({codEmail: main.ema_uni_codigo})\" class=\"btn btn-xs btn-primary pull-right\"><i class=\"fa fa-link\"></i></a><div class=clearfix></div></div><div class=\"panel-body animated fadeIn anime-0-6s\" ng-if=main.subject><div class=form-group><label class=text-muted>Destinatário</label><input type=text class=form-control ng-model=main.to readonly></div><div class=form-group><label class=text-muted>Assunto</label><input type=text class=form-control ng-model=main.subject readonly></div><div><label class=text-muted>Status</label><div style=margin-bottom:0 class=\"well well-sm\"><div class=\"row flipInX anime-0-8s\" ng-if=\"main.lastStatus.status === \'processado\'\"><div class=\"col-xs-12 text-center\"><h4 style=\"margin-top: 7px\"><i class=\"fa fa-cogs fa-lg\"></i> {{main.lastStatusFormat}}</h4></div></div><div class=\"row animated flipInX anime-0-8s\" ng-if=\"main.lastStatus.status === \'enviado\'\"><div class=\"col-xs-12 text-center\"><h4 style=\"margin-top: 7px\" class=text-primary><i class=\"fa fa-paper-plane fa-lg text-primary\"></i> {{main.lastStatusFormat}}</h4></div></div><div class=\"row animated flipInX anime-0-8s\" ng-if=\"main.lastStatus.status === \'entregue\'\"><div class=\"col-xs-12 text-center\"><h4 style=\"margin-top: 7px\" class=text-success><i class=\"fa fa-check fa-lg text-success\"></i> {{main.lastStatusFormat}}</h4></div></div><div class=\"row animated flipInX anime-0-8s\" ng-if=\"main.lastStatus.status === \'lido\'\"><div class=\"col-xs-12 text-center\"><h4 class=\"text-warning h-no-margin\"><i class=\"fa fa-eye fa-lg text-warning\"></i> {{main.lastStatusFormat}}</h4></div></div><div class=\"row animated flipInX anime-0-8s\" ng-if=\"main.lastStatus.status === \'erro\'\"><div class=\"col-xs-12 text-center\"><h4 style=\"margin-top: 7px\" class=text-danger><i class=\"fa fa-exclamation-triangle fa-lg text-danger\"></i> {{main.lastStatusFormat}}</h4></div></div></div></div></div><div class=panel-body ng-if=!main.ema_uni_data_criacao><h4 class=\"text-center text-muted\">Nenhum Registro Encontrado</h4></div><div ng-if=main.ema_uni_data_criacao class=\"panel-footer text-center animated fadeIn anime-0-6s\">Data da Criação: {{main.ema_uni_data_criacao}}</div></div></div></div></div>");
$templateCache.put("app/modelos/modelos.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=# class=\"btn btn-default\"><span class=text-muted>Campanhas</span> </a><a href=/campanhas/modelos class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Modelos de E-mail</span></a></div><div class=page-header><h2>Modelos de E-mail <button class=\"pull-right popover-help text-muted btn-link animated pulse infinete\" data-toggle=popover title=\"Modelos de E-mail\" data-content=\"Modelos de e-mail criados. Para criação de novo Modelo, utilize o botão Criar Novo Modelo, para edição do modelo de e-mail, clique no título do mesmo ou utilize a opção Editar no menu da grade.\" data-placement=left data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><div class=\"panel panel-default h-no-margin\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">{{modelo.tituloView}}</h3><a class=\"btn btn-primary btn-xs pull-right\" href=/campanhas/novo-modelo><i class=\"fa fa-plus hidden-sm hidden-md hidden-lg\"></i> <span class=hidden-xs>Novo Modelo</span></a><div class=clearfix></div></div></div><div><table datatable=\"\" dt-instance=modelo.dtInstance dt-options=modelo.dtOptions dt-columns=modelo.dtColumns class=\"table table-striped table-hover table-bordered\"></table></div></div></div></div>");
$templateCache.put("app/modelos/novo-modelo.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=# class=\"btn btn-default\"><span class=text-muted>Campanhas</span> </a><a href=/campanhas/modelos class=\"btn btn-default\"><span class=text-muted>Modelos de E-mail</span> </a><a href=/campanhas/modelos/novo-modelo class=\"btn btn-default animated fadeInRight\"><span class=text-muted ng-if=!modelo.formModelo.mod_codigo>Novo Modelo</span> <span class=text-muted ng-if=modelo.formModelo.mod_codigo>Editar Novo Modelo</span></a></div><div class=page-header><h2><span ng-if=!modelo.formModelo.mod_codigo>Novo Modelo</span> <span ng-if=modelo.formModelo.mod_codigo>Editar Novo Modelo</span> <button class=\"pull-right popover-help text-muted btn-link animated pulse infinete\" data-toggle=popover title=\"Novo Modelo\" data-content=\"Para criação de Novo Modelo preencha um nome para o mesmo, o assunto e o conteúdo da mensagem. Utilize as variáveis para inserir informações específicas de cada e-mail.\" data-placement=left data-container=body data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><form method=post ng-submit=modelo.save()><div class=form-group ng-if=!modelo.isAdding><label class=label-control>Codigo do Modelo</label><input type=text class=form-control name=name required ng-model=modelo.formModelo.mod_codigo disabled></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nome do Modelo <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><input type=text class=form-control name=name required ng-model=modelo.formModelo.mod_name></div><div>{{modelo.options}}</div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Assunto <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><div class=input-group><input type=text class=form-control name=subject required ng-model=modelo.formModelo.mod_subject> <span class=input-group-btn uib-dropdown><button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle aria-haspopup=true type=button>Variáveis <span class=caret></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu><li ng-repeat=\"variavel in modelo.variaveisSubject\" ng-click=\"modelo.addVariavelSubject(\'subject\', variavel.var_chave)\"><a href=#>{{variavel.var_valor}}</a></li></ul></span></div></div><div style=\"margin-bottom: 15px\"><textarea name=tinymce ui-tinymce=modelo.tinymceOptions ng-model=modelo.formModelo.mod_content ng-if=modelo.tinymceOptions></textarea></div><div class=form-group><button type=submit class=\"btn btn-primary pull-right btn-lg\">Salvar</button><div class=clearfix></div></div></form></div></div></div>");
$templateCache.put("app/usuario/usuario-modal.html","<div class=modal-header><button type=button class=close ng-click=\"$dismiss(\'cancel\');\" aria-label=Close><span aria-hidden=true><i class=\"fa fa-times\"></i></span></button><h2 class=\"modal-title text-primary\"><span ng-if=!usuarioModal.isAdding>Editar Usuário</span> <span ng-if=usuarioModal.isAdding>Novo Usuário</span> <button class=\"popover-help text-muted btn-link\" data-toggle=popover title=\"Novo Usuário\" data-content=\"Preencha corretamente os campos solicitados para a criação de um novo usuário do AR-Email. O novo usuário receberá um e-mail com todas as informações necessária para acessar o sistema.\" data-placement=bottom data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><form name=form ng-submit=usuarioModal.saveUsuario() method=post><div class=modal-body><div class=\"page-header h-no-margin-top\"><h3 class=\"text-muted h-no-margin-top\">Configuração de Conta</h3></div><div class=form-group ng-if=!usuarioModal.isAdding><label class=label-control>Código do Usuário</label><input disabled name=usu_codigo type=text class=form-control ng-model=usuarioModal.form.usu_codigo required></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Nome do Usuário <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=\"Nome do Usuário\" data-content=\"O nome do usuário é o nome que será usado pelo mesmo como identificador no sistema.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button> <input name=usu_codigo type=text class=form-control ng-model=usuarioModal.form.usu_nome required></div><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Login <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=Login data-content=\"O e-mail do usuário que será usado para acesso ao sistema.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button> <input name=usu_login type=email class=form-control ng-model=usuarioModal.form.usu_login required></div><!-- Tipo de usuario --><div class=form-group><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Tipo de Usuário <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=\"Tipo de Usuário\" data-content=\"O Tipo de Autenticação é o serviço de correio eletrônico utilizado pelo E-mail Válido.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button><ui-select ng-model=usuarioModal.form.usu_nivel><ui-select-match placeholder=\"Tipo de Usuário\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"tipoUsuario.value as tipoUsuario in usuarioModal.selectTipoUsuario | filter:$select.search\"><div ng-bind-html=\"tipoUsuario.name | highlight: $select.search\"></div></ui-select-choices></ui-select><!-- <select selector model=\"usuarioModal.form.usu_nivel\" options=\"usuarioModal.selectTipoUsuario\" value-attr=\"value\" label-attr=\"name\" required></select> --></div><!-- Envio de anexo obrigatório --><div class=form-group><label class=label-control title=\"Campo Obrigatório\">Envio de Anexo Obrigatório <input class=\"checkbox pull-left\" type=checkbox ng-model=usuarioModal.form.usu_anexo_obrigatorio ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\"></label><button class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=Login data-content=\"O usuário será obrigado e enviar emails com anexos.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button></div><!-- Tipo de usuario --><!-- Empresa --><div class=form-group ng-if=\"usuarioModal.userNivel == 3?true:false\"><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Empresa <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=\"Tipo de Usuário\" data-content=\"O Tipo de Autenticação é o serviço de correio eletrônico utilizado pelo E-mail Válido.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button><ui-select ng-model=usuarioModal.form.cod_ger_empresa on-select=\"usuarioModal.entidadeByEmpresa($item, $model)\"><ui-select-match placeholder=Empresa>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"empresa.value as empresa in usuarioModal.selectEmpresa | filter:$select.search\"><div ng-bind-html=\"empresa.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><!-- Empresa --><!-- Entidade --><div class=form-group ng-if=\"usuarioModal.userNivel >= 2?true:false\"><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Entidade <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=\"Tipo de Usuário\" data-content=\"O Tipo de Autenticação é o serviço de correio eletrônico utilizado pelo E-mail Válido.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button><ui-select ng-model=usuarioModal.form.cod_ger_entidade><ui-select-match placeholder=Entidade>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"entidade.value as entidade in usuarioModal.selectEntidade | filter:$select.search\"><div ng-bind-html=\"entidade.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><!-- Entidade --><div class=form-group ng-if=\"usuarioModal.userNivel == 3?true:false\"><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">Status do Email <small><i class=\"fa fa-asterisk text-danger\" aria-hidden=true></i></small></label><button class=\"popover-help text-muted btn-link\" data-toggle=popover type=button title=\"Tipo de Usuário\" data-content=\"O Tipo de Autenticação é o serviço de correio eletrônico utilizado pelo E-mail Válido.\" data-placement=right data-trigger=hover><i class=\"fa fa-question-circle\"></i></button><ui-select ng-model=usuarioModal.form.usu_status><ui-select-match placeholder=\"Status do Email\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"statusEmail.value as statusEmail in usuarioModal.selectStatusEmail | filter:$select.search\"><div ng-bind-html=\"statusEmail.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><!-- Configuração de E-mail --><div class=form-group ng-if=\"!usuarioModal.isAdding && usuarioModal.userNivel == 3 ? true : false\"><label class=label-control data-toggle=tooltip data-placement=right title=\"Campo Obrigatório\">EVK</label><input name=ema_evk type=text class=form-control ng-model=usuarioModal.form.email.ema_evk></div></div><div class=modal-footer><div class=\"btn-group btn-group-justified\" role=group aria-label=\"Botões de Ação\"><div class=btn-group role=group><button class=\"btn btn-warning\" type=button ng-click=usuarioModal.cleanForm()><i class=\"fa fa-eraser\"></i> Limpar</button></div><div class=btn-group role=group><button class=\"btn btn-danger\" type=button ng-click=\"$dismiss(\'cancel\');\"><i class=\"fa fa-times\"></i> Fechar</button></div><div class=btn-group role=group><button class=\"btn btn-primary\" type=submit ng-disabled=usuarioModal.$invalid><i class=\"fa fa-save\"></i> Salvar</button></div></div></div></form><script>$(\'[data-toggle=\"popover\"]\').popover();\n    $(\'[data-toggle=\"tooltip\"]\').tooltip();</script><!-- Configuração de E-mail --> <!-- <div class=\"page-header\">\n    <h3 class=\"text-muted\">Configuração de E-mail</h3>\n</div>\n<div class=\"form-group\" ng-if=\"false\">\n    <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">Codigo Email\n        <small>\n            <i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i>\n        </small>\n    </label>\n    <input name=\"ema_email\" type=\"text\" class=\"form-control\" ng-model=\"usuarioModal.form.email.ema_codigo\" required>\n</div>\n\n<div class=\"form-group\">\n    <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">Nome Remetente\n        <small>\n            <i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i>\n        </small>\n    </label>\n    <button class=\"popover-help text-muted btn-link\" data-toggle=\"popover\" type=\"button\" title=\"Nome Remetente\" data-content=\"O nome que irá compor o cabeçalho do e-mail como responsável pelo envio. O nome do Remetente pode ser o mesmo que o Nome do usuário.\" data-placement=\"right\" data-trigger=\"hover\">\n        <i class=\"fa fa-question-circle\"></i>\n    </button>\n    <input name=\"ema_email\" type=\"text\" class=\"form-control\" ng-model=\"usuarioModal.form.email.ema_nome\" required>\n</div>\n\n<div class=\"form-group\">\n    <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">E-mail Válido\n        <small>\n            <i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i>\n        </small>\n    </label>\n    <button class=\"popover-help text-muted btn-link\" data-toggle=\"popover\" type=\"button\" title=\"E-mail Válido\" data-content=\"É o e-mail que irá compor o cabeçalho da mensagem como responsável pelo envio. O e-mail válido pode ser o mesmo que o do login.\" data-placement=\"right\" data-trigger=\"hover\">\n        <i class=\"fa fa-question-circle\"></i>\n    </button>\n    <input name=\"ema_email\" type=\"text\" class=\"form-control\" ng-model=\"usuarioModal.form.email.ema_email\" ng-change=\"usuarioModal.changeEmailValido()\" required>\n</div>\n\n<div class=\"form-group\" ng-hide=\"true\">\n    <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">EVK\n        <small>\n            <i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i>\n        </small>\n    </label>\n    <input name=\"ema_evk\" type=\"text\" class=\"form-control\" ng-model=\"usuarioModal.form.email.ema_evk\" required disabled>\n</div>\n\n<div class=\"form-group\">\n    <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">Tipo de Autenticação<small>\n            <i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i>\n        </small>\n    </label>\n    <button class=\"popover-help text-muted btn-link\" data-toggle=\"popover\" type=\"button\" title=\"Tipo de Autenticação\" data-content=\"O Tipo de Autenticação é o serviço de correio eletrônico utilizado pelo E-mail Válido.\" data-placement=\"right\" data-trigger=\"hover\">\n        <i class=\"fa fa-question-circle\"></i>\n    </button>\n\n    <ui-select ng-model=\"usuarioModal.form.email.ema_smtp_type\" on-select=\"usuarioModal.changeTypeAuth($item, $model)\">\n        <ui-select-match placeholder=\"Smtp Type\">{{$select.selected.name}}</ui-select-match>\n        <ui-select-choices repeat=\"smtpType.value as smtpType in usuarioModal.selectSmtpTypes | filter:$select.search\">\n            <div ng-bind-html=\"smtpType.name | highlight: $select.search\"></div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n\n<div class=\"form-group\">\n    <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">Host\n        <small>\n            <i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i>\n        </small>\n    </label>\n    <button class=\"popover-help text-muted btn-link\" data-toggle=\"popover\" type=\"button\" title=\"Host\" data-content=\"SMTP do serviço de e-mail utilizado. Para maiores informações, acesse o nosso Help.\" data-placement=\"right\" data-trigger=\"hover\">\n        <i class=\"fa fa-question-circle\"></i>\n    </button>\n    <input name=\"ema_smtp_host\" type=\"text\" class=\"form-control\" ng-model=\"usuarioModal.form.email.ema_smtp_host\" required>\n</div>\n\n<div class=\"form-group\">\n    <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">Porta\n        <small>\n            <i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i>\n        </small>\n    </label>\n    <button class=\"popover-help text-muted btn-link\" data-toggle=\"popover\" type=\"button\" title=\"Porta\" data-content=\"Porta de conexão para transferência de Dados. Para maiores informações, acesse o nosso Help.\" data-placement=\"right\" data-trigger=\"hover\">\n        <i class=\"fa fa-question-circle\"></i>\n    </button>\n\n    <ui-select ng-model=\"usuarioModal.form.email.ema_smtp_port\">\n        <ui-select-match placeholder=\"Portal\">{{$select.selected.name}}</ui-select-match>\n        <ui-select-choices repeat=\"smtpPort.value as smtpPort in usuarioModal.selectSmtpPorts | filter:$select.search\">\n            <div ng-bind-html=\"smtpPort.name | highlight: $select.search\"></div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n\n<div class=\"form-group\">\n    <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">Tipo de Autenticação\n        <small>\n            <i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i>\n        </small>\n    </label>\n    <button class=\"popover-help text-muted btn-link\" data-toggle=\"popover\" type=\"button\" title=\"Tipo de Autenticação\" data-content=\"Autenticação para transmissão de dados. Para maiores informações, acesse o nosso Help.\" data-placement=\"right\" data-trigger=\"hover\">\n        <i class=\"fa fa-question-circle\"></i>\n    </button>\n    <ui-select ng-model=\"usuarioModal.form.email.ema_smtp_type_auth\">\n        <ui-select-match placeholder=\"Portal\">{{$select.selected.name}}</ui-select-match>\n        <ui-select-choices repeat=\"smtpTypeAuth.value as smtpTypeAuth in usuarioModal.selectSmtpTypeAuthentications | filter:$select.search\">\n            <div ng-bind-html=\"smtpTypeAuth.name | highlight: $select.search\"></div>\n        </ui-select-choices>\n    </ui-select>\n\n</div>\n\n<div class=\"form-group\">\n    <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">Usuário\n        <small>\n            <i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i>\n        </small>\n    </label>\n    <input name=\"ema_smtp_auth_user\" type=\"text\" class=\"form-control\" ng-model=\"usuarioModal.form.email.ema_smtp_auth_user\" required>\n</div>\n\n<div class=\"form-group\">\n    <label class=\"label-control\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Campo Obrigatório\">Senha\n        <small>\n            <i class=\"fa fa-asterisk text-danger\" aria-hidden=\"true\"></i>\n        </small>\n    </label>\n    <button class=\"popover-help text-muted btn-link\" data-toggle=\"popover\" type=\"button\" title=\"Senha\" data-content=\"A senha usada no e-mail que foi preenchido no campo E-mail Válido. Essa informação é criptografada.\" data-placement=\"right\" data-trigger=\"hover\">\n        <i class=\"fa fa-question-circle\"></i>\n    </button>\n    <input name=\"ema_smtp_auth_password\" type=\"password\" class=\"form-control\" ng-model=\"usuarioModal.form.email.ema_smtp_auth_password\" required>\n</div> -->");
$templateCache.put("app/usuario/usuario.html","<div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"container-fluid container-semi-fluid\"><div class=\"btn-group btn-breadcrumb btn-group-xs\"><a href=/home class=\"btn btn-default\"><i class=\"fa fa-home text-primary\"></i> </a><a href=# class=\"btn btn-default\"><span class=text-muted>Cadastros</span> </a><a href=# class=\"btn btn-default animated fadeInRight\"><span class=text-muted>Usuário</span></a></div><div class=page-header><h2>Cadastro de Usuário <button class=\"pull-right popover-help text-muted btn-link btn-link animated pulse infinete\" data-toggle=popover title=\"Cadastro de Usuário\" data-content=\"Lista de Usuários cadastrados no sistema. Para adição de novo usuário utilize a opção Novo Usuário no canto superior direito\" data-placement=left data-trigger=hover><i class=\"fa fa-question-circle-o\"></i></button></h2></div><div class=row><div class=col-xs-12><div class=\"panel panel-default h-no-margin\"><div class=panel-heading><h3 class=\"panel-title pull-left text-primary\">{{usuario.tituloView}}</h3><button type=button class=\"btn btn-xs btn-primary pull-right\" ng-click=usuario.openModal(true)><i class=\"fa fa-plus hidden-sm hidden-md hidden-lg\"></i> <span class=hidden-xs>Novo Usuário</span></button><div class=clearfix></div></div></div><div><table datatable=\"\" dt-instance=usuario.dtInstance dt-options=usuario.dtOptions dt-columns=usuario.dtColumns class=\"table table-striped table-hover table-bordered\"></table></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav style=\"margin-bottom: 0\" class=\"navbar navbar-default navbar-fixed-top\"><div class=container-fluid><div class=navbar-header><button style=\"color: #9D9D9D;padding: 7px 10px 6px\" type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse-main aria-expanded=false><i class=\"fa fa-bars fa-2x\"></i></button> <a class=navbar-brand href=/home><img alt=\"Ar Mail Logo\" class=\"animated tada\" style=\"max-width:112px; height:45.5px\" src=/assets/images/main-logo-horizontal.svg></a></div><div class=\"collapse navbar-collapse\" id=navbar-collapse-main><ul class=\"nav navbar-nav\" bs-navbar><li data-match-route=/home><a ng-href=/home>Dashboard</a></li><li class=dropdown uib-dropdown data-match-route=/cadastro><a href class=dropdown-toggle uib-dropdown-toggle role=button>Cadastros <span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu><li ng-if=\"vm.user.usu_nivel >= 3\" class=hidden><a href=/cadastro/empresa title=Empresas>* Empresas</a></li><li ng-if=\"vm.user.usu_nivel >= 2\" class=hidden><a href=/cadastro/entidades title=Entidades>* Entidades</a></li><li ng-if=\"vm.user.usu_nivel >= 1\"><a href=/cadastro/usuario title=Usuários>Usuários</a></li><li><a href=/leads title=Leads/Contatos>Leads/Contatos</a></li><li><a href=/etiquetas title=Etiquetas>Etiquetas</a></li></ul></li><li class=dropdown uib-dropdown data-match-route=/campanhas><a href class=dropdown-toggle uib-dropdown-toggle role=button>Campanhas <span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu><li class=hidden><a href=/campanhas/campanhas title=\"Minhas Campanhas\">* Minhas Campanhas</a></li><li class=hidden><a href=/campanhas/lista title=\"Lista de E-mails\">* Lista de E-Mails</a></li><li><a href=/campanhas/modelos title=\"Modelos de E-mail\">Modelos de E-Mail</a></li></ul></li><li class=dropdown uib-dropdown data-match-route=/mail-unico><a href class=dropdown-toggle uib-dropdown-toggle role=button>E-Mails <span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu><li><a ng-href=/mail-unico/mail-unico title=\"E-mail Único\">E-Mails Enviados</a></li></ul></li><li><a ng-href=/mail-unico/novo-mail-unico title=\"Envie E-mail Agora\">Enviar <i class=\"fa fa-paper-plane\" aria-hidden=true></i></a></li><!-- <li data-match-route=\"/mail-unico/mail-unico\">\n					<a ng-href=\"/mail-unico/mail-unico\" title=\"E-mail Único\">\n						E-mail Único\n					</a>\n				</li> --><!-- <li class=\"dropdown\" uib-dropdown data-match-route=\"/cadastro/campanhas\">\n					<a href class=\"dropdown-toggle\" uib-dropdown-toggle role=\"button\">\n						Testes\n						<span class=\"caret\">\n						</span>\n					</a>\n					<ul class=\"dropdown-menu\" uib-dropdown-menu>\n						<li>\n							<a href=\"/testes/email-unico\">\n								E-mail Único\n							</a>\n						</li>\n						<li>\n							<a href=\"/testes/csv\">\n								CSV\n							</a>\n						</li>\n						<li>\n							<a href=\"/testes/tinymce\">\n								Tinymce\n							</a>\n						</li>\n						<li>\n							<a href=\"/testes/datatable\">\n								DataTables\n							</a>\n						</li>\n					</ul>\n				</li> --></ul><ul class=\"nav navbar-nav navbar-right\"><li class=dropdown uib-dropdown><a href=# class=dropdown-toggle uib-dropdown-toggle role=button aria-haspopup=true aria-expanded=false><span class=\"fa fa-cog fa-lg\"></span></a><ul class=dropdown-menu uib-dropdown-menu title=Configurações><li><a href=/configuracao>Configurações</a></li><li><a href=#myModal-about data-toggle=modal title=Sobre>Sobre</a></li><li role=separator class=divider></li><li><a href=/logout title=Sair>Sair</a></li></ul></li></ul></div></div></nav><uib-alert style=\"position: relative;top: 70px; z-index:1\" ng-repeat=\"alert in vm.alerts\" type={{alert.type}} close=vm.closeAlert($index)><div ng-bind-html=alert.msg></div></uib-alert>");
$templateCache.put("app/testes/csv/csv.html","<div><acme-navbar></acme-navbar></div><div class=container-fluid><div class=page-header><h2>{{csv.tituloView}} <button class=\"pull-right popover-help text-muted btn-link\" data-toggle=popover title=\"Popover title\" data-content=\"And here\'s some amazing content. It\'s very engaging. Right?\" data-placement=left><i class=\"fa fa-question-circle\"></i></button></h2></div><div><div><h4>Selecione CSV file:</h4>Para csv é importante que as colunas no CSV sejam Nome e Email</div><div class=\"block right\"><ng-csv-import class=\"import button\" content=csv.csv.content header=csv.csv.header separator=csv.csv.separator result=csv.csv.result encoding=csv.csv.encoding></ng-csv-import></div></div><div class=content>Leitura do arquivo<pre>\n    		{{csv.csv.result}}\n    	</pre></div><div class=\"panel panel-default\"><!-- Default panel contents --><div class=panel-heading>Uso do CSV</div><div><table class=table><thead><tr><th>#</th><th>Nome</th><th>Email</th></tr></thead><tbody><tr ng-repeat=\"linhaCsv in csv.csv.result\"><th scope=row>{{$index + 1}}</th><td>{{linhaCsv.Nome}}</td><td>{{linhaCsv.Email}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/testes/datatables/datatable.html","<div><acme-navbar></acme-navbar></div><div class=container-fluid><div class=page-header><h2>{{datatable.tituloView}} <button class=\"pull-right popover-help text-muted btn-link\" data-toggle=popover title=\"Popover title\" data-content=\"And here\'s some amazing content. It\'s very engaging. Right?\" data-placement=left><i class=\"fa fa-question-circle\"></i></button></h2></div><div><!-- <table datatable=\"\" class=\"row-border hover\"> --><table datatable=\"\" dt-options=datatable.dtOptions dt-column-defs=datatable.dtColumnDefs class=\"table table-striped table-hover\"><thead><tr><th>ID</th><th>Primeiro Nome</th><th>Segundo Nome</th><th>E-mail</th></tr></thead><tbody><tr><td>1</td><td>Welinton</td><td>Subtil</td><td>welinton@realizati.com.br</td></tr><tr><td>2</td><td>Rafael</td><td>Araujo</td><td>rafael@realizati.com.br</td></tr><tr><td>3</td><td>Roberto</td><td>Addario</td><td>roberto@realizati.com.br</td></tr></tbody></table></div></div>");
$templateCache.put("app/testes/email-unico/email-unico.html","<div><acme-navbar></acme-navbar></div><div class=container-fluid><div class=page-header><h2>{{emailUnico.tituloView}} <button class=\"pull-right popover-help text-muted btn-link\" data-toggle=popover title=\"Popover title\" data-content=\"And here\'s some amazing content. It\'s very engaging. Right?\" data-placement=left><i class=\"fa fa-question-circle\"></i></button></h2></div><div><form method=post ng-submit=emailUnico.submitForm()><div class=form-group><label class=label-control>De:</label><select selector model=emailUnico.formEmail.codUsuario options=emailUnico.formEmail.usuarios value-attr=value label-attr=name></select></div><div class=form-group><label class=label-control>Nome do Destinatário:</label><input name=usu_codigo type=text class=form-control ng-model=emailUnico.formEmail.nameTo></div><div class=form-group><label class=label-control>Email:</label><input name=usu_codigo type=text class=form-control ng-model=emailUnico.formEmail.to required></div><div class=form-group><label class=label-control>Para:</label><input name=usu_codigo type=text class=form-control ng-model=emailUnico.formEmail.subject required></div><div class=form-group><button type=button class=\"btn btn-primary\" ng-model=emailUnico.formEmail.valid uib-btn-checkbox btn-checkbox-true=true btn-checkbox-false=false>Válido?</button></div><div class=form-group><textarea ui-tinymce=emailUnico.tinymceOptions ng-model=emailUnico.formEmail.content></textarea></div><!-- <br>\n      <textarea ui-tinymce=\"emailUnico.tinymceOptions\" ng-model=\"emailUnico.formEmail.content\"></textarea>\n      <br/> --><!-- <button class=\"btn btn-primary\" ng-click=\"emailUnico.getContent()\">Get content</button>\n      <button class=\"btn btn-primary\" ng-click=\"emailUnico.setContent()\">Set content</button> --> <button type=submit class=\"btn btn-primary\">Enviar</button></form></div></div>");
$templateCache.put("app/testes/tinymce/tinymce.html","<div><acme-navbar></acme-navbar></div><div class=container-fluid><div class=page-header><h2><textarea ui-tinymce ng-model=tinymceModel></textarea>{{tiny.tituloView}} <button class=\"pull-right popover-help text-muted btn-link\" data-toggle=popover title=\"Popover title\" data-content=\"And here\'s some amazing content. It\'s very engaging. Right?\" data-placement=left><i class=\"fa fa-question-circle\"></i></button></h2></div><div><form method=post><textarea ui-tinymce=tiny.tinymceOptions ng-model=tiny.tinymceModel></textarea><button ng-click=tiny.getContent()>Get content</button> <button ng-click=tiny.setContent()>Set content</button></form></div></div>");}]);